/* ============================================================
   Egaline Totaal — et-keuzehulp.js (keuzehulp v2)
   Drie beslispaden uit PDF Ikko_Egaline_Keuzelogica v2.9:
   A Egaliseren · B Sleuven dichtzetten · C Opbouw ingieten.
   - Regels: resolveAdvies(state) -> adviesobject
   - Stappen: bepaalStappen(state) -> array panel-ids (sequence-engine)
   - Data: #et-keuzehulp-data (snippets/keuzehulp-modal.liquid),
     platte productmap op key; null = nog niet online bestelbaar
     (DRAFT/onbestaand) -> nvt-variant met WhatsApp-CTA.
   - Meting: anonieme gebeurtenissen per sessie naar DATA.meting.url
     (thema-instelling Keuzehulp-meting); zie het blok 'Meting' hieronder.
   Cart-add hergebruikt het native patroon uit app.js
   (sections=main-cart,cart-drawer,cart-bubble + drawer openen).
   ============================================================ */
(function () {
  'use strict';

  var overlay = document.getElementById('et-kh-overlay');
  var dataEl = document.getElementById('et-keuzehulp-data');
  if (!overlay || !dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Keuzehulp: ongeldige data', e);
    return;
  }
  var PRODUCTEN = DATA.producten || {};

  /* ===== Meting (anoniem) =====
     Stuurt per keuzehulpsessie een handvol gebeurtenissen (open, antwoord,
     advies, specialist, whatsapp, cart, cart_fout, sluit) naar het
     meet-endpoint uit de thema-instellingen (Egaline Totaal > Keuzehulp-meting,
     via het datablock als DATA.meting). Geen URL = er wordt niets verstuurd.
     Anoniem bij ontwerp: geen cookie of opslag, een willekeurig sessie-id dat
     alleen in het geheugen van deze modal leeft, geen klantgegevens — alleen
     de antwoorden, het advies en de knop die de klant koos. Met
     DATA.meting.consent aan volgt de meting de analytics-toestemming van de
     winkel (Shopify.customerPrivacy). Verzenden gaat fire-and-forget via
     sendBeacon als text/plain (geen CORS-preflight); mislukt dat stil, dan
     merkt de klant er niets van. Ontvanger: KEUZEHULP-METING/keuzehulp-collector.gs
     (Google Apps Script -> tabblad Sessies), dashboard leest die sheet. */
  var METING = DATA.meting || {};
  var meetUrl = typeof METING.url === 'string' ? METING.url.trim() : '';
  var meetSid = null;
  var meetTeller = 0;
  var meetAfgerond = false;
  var huidigeView = 'vragen';
  var huidigRoute = '';
  function meetToegestaan() {
    if (!meetUrl) return false;
    if (!METING.consent) return true;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return true;
    try { return !!cp.analyticsProcessingAllowed(); } catch (e) { return true; }
  }
  function nieuwSid() {
    var s = '';
    try {
      var b = new Uint8Array(8);
      window.crypto.getRandomValues(b);
      for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
    } catch (e) {
      s = Date.now().toString(16) + Math.random().toString(16).slice(2, 10);
    }
    return s;
  }
  function meet(ev, extra) {
    if (!meetSid || !meetToegestaan()) return;
    var p = {
      sid: meetSid,
      n: ++meetTeller,
      ev: ev,
      t: Date.now(),
      device: window.innerWidth < 768 ? 'mobiel' : 'desktop',
      pad: window.location.pathname
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k] !== undefined && extra[k] !== null && extra[k] !== '') p[k] = extra[k];
      }
    }
    var body = JSON.stringify(p);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(meetUrl, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) { /* valt door naar fetch */ }
    try {
      fetch(meetUrl, { method: 'POST', body: body, mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e2) { /* de meting is nooit blokkerend */ }
  }
  /* Waar de klant de keuzehulp opende. De triggers zijn herkenbare blokken:
     band-kaarten en -CTA (sections/et-keuzehulp-band.liquid), de grid-CTA op
     de collectiepagina, de blogband, de lege cart-drawer en losse links naar
     #egaline-wijzer. */
  function meetBron(t) {
    if (!t || !t.closest) return 'overig';
    if (t.closest('#Cart-Drawer')) return 'cart-drawer';
    if (t.classList.contains('et-home-keuzehulp-card')) return 'band-kaart';
    if (t.classList.contains('et-home-keuzehulp__cta')) return 'band-cta';
    if (t.classList.contains('et-col-gridcta--knop') || t.closest('.et-col-gridcta')) return 'collectie';
    if (t.classList.contains('et-blog-band__keuzehulp')) return 'blog';
    if ((t.getAttribute('href') || '').indexOf('#egaline-wijzer') !== -1) return 'link';
    return 'overig';
  }
  function meetStart(trigger) {
    meetSid = nieuwSid();
    meetTeller = 0;
    meetAfgerond = false;
    huidigRoute = '';
    /* prefill = wat de knop zelf vooraf koos (data-doel / legacy data-ondergrond),
       niet wat er nog in het geheugen stond van een eerdere sessie. */
    var prefill = trigger && trigger.getAttribute ? (trigger.getAttribute('data-doel') || trigger.getAttribute('data-ondergrond') || '') : '';
    meet('open', { bron: meetBron(trigger), prefill: prefill });
  }
  /* Sluiten zonder afronding = afhaken; na een geslaagde cart-add (meetCart)
     is de sessie al afgerond en volgt er geen sluit-event. */
  function meetSluit() {
    if (meetAfgerond) return;
    meetAfgerond = true;
    meet('sluit', { stap: huidigeStap, view: huidigeView });
  }
  function meetAdvies(advies, qty, nvt, uitverkocht) {
    huidigRoute = nvt ? 'nvt' : (uitverkocht ? 'uitverkocht' : 'koop');
    meet('advies', {
      doel: state.doel,
      groep: state.groep,
      vocht: state.vocht,
      bOndergrond: state.bOndergrond,
      bZelfdeDag: state.bZelfdeDag,
      cSysteem: state.cSysteem,
      m2: state.m2,
      mm: state.mm,
      product: advies.hoofd.key,
      zakken: qty,
      route: huidigRoute,
      voorstrijk: advies.voorstrijk ? advies.voorstrijk.key : '',
      rand: advies.randisolatie ? 1 : 0
    });
  }
  function meetCart(items) {
    meetAfgerond = true;
    meet('cart', {
      product: huidigAdvies ? huidigAdvies.hoofd.key : '',
      zakken: huidigAdvies ? huidigAdvies.hoofd.qty : 0,
      regels: items.length,
      bedrag: berekenTotaal()
    });
  }

  var modal = document.getElementById('et-kh-modal');
  var vragen = document.getElementById('et-kh-vragen');
  var resultaat = document.getElementById('et-kh-resultaat');
  var specialist = document.getElementById('et-kh-specialist');

  var WA_NUMMER = '31657314211';

  /* ===== Declaratieve regels & copy (vervangt de keuzehulp_advies-metaobjects) ===== */
  var KH_CONFIG = {
    zakKg: 20,                  /* zak van 20 kg in alle formules (PDF) */
    /* ONBEVESTIGDE AANNAME (nagezocht 08-09-2026, niets gevonden).
       Dit is het enige getal in deze module zonder bron:
       - de PDF geeft bij S500 en S550 alleen de toepassing, geen rendement
         (wel kg/m2/mm bij de egalines en 8-10 m2/zak bij de vulmortels);
       - S500 heeft geen specs.verbruik, geen specs.inhoud_kg en geen TDS;
         zijn omschrijving noemt dichtheid en vaste stof, geen m2 per bus;
       - geen enkel ander voorstrijk/primer-product in de winkel (30 gecheckt)
         heeft die velden wel;
       - KEUZEHULP-V2-SPEC.md noemt het zelf een aanname.
       Daarom blijft het getal staan (een ander verzonnen getal verplaatst het
       probleem alleen) maar noemt het scherm het voortaan hardop: busTekst()
       zet "(±35 m2 per bus)" op de voorstrijkrij, zodat de klant ziet waarmee
       gerekend is. Vraag aan de leverancier/Robbin staat in de oplevering.
       Zodra het echte rendement bekend is: dit getal aanpassen, en als S550
       een ander rendement heeft, hier splitsen per sleutel. */
    voorstrijkM2PerCan: 35,
    sleuvenM2PerZak: 8,         /* conservatieve kant van 8-10 m2 per zak */
    /* Of de winkel de staffelprijs zelf afrekent is PER PRODUCT bepaald, niet
       hier. Sinds 11-09-2026 bestaan de automatische kortingen echt (16 stuks,
       SCHEDULED vanaf di 15-09 15:00) maar alleen op IKKO-producten; de
       staffelmetavelden staan ook op UZIN/Atlas/Mapei, waar de kassa gewoon de
       volle prijs rekent. Het datablock levert daarom per product
       "staffelAuto" (vendor == 'IKKO', zelfde afleiding als
       staffel_automatisch in snippets/product-staffelblok.liquid); de helper
       staffelAuto() hieronder leest dat veld. Een themabrede vlag zou bij een
       UZIN-zak een korting beloven die de checkout niet geeft. */
    /* Levertijdbelofte in de voet. "Voor 14:00 besteld, volgende werkdag
       geleverd" is de belofte uit de topbar en die gaat over een gewone
       webbestelling. Boven een bulkhoeveelheid laten we hem vallen (zie
       BULK_VANAF): we claimen daarmee niets nieuws, we beloven alleen minder. */
    levertijdBulk: 'Levertijd op aanvraag bij dit aantal',
    kgPerM2: { noppenplaat: 34, klemrail: 39, tacker: 39 },
    elektrischMinMm: 5,
    /* Rollengte randisolatie. Geen aanname maar een productgegeven: de
       omschrijving van "Randisolatie met plakrand" noemt "een lengte van 25
       meter" (nagekeken 08-09-2026). Het staat in geen metafield, dus het
       staat hier — verandert de leverancier de rol, dan moet dit getal mee.
       Wat wél geschat is, is de omtrek (randOmtrek); dat staat zo op de
       resultaatkaart. */
    randRolMeter: 25,
    /* Invoergrenzen (beide velden zijn type=text, dus min/max/step van de
       browser vervallen; hier ligt de enige bron).
       m2Max 2000: een vloer die je met zakgoed van 20 kg egaliseert. 2000 m²
       bij 5 mm is al ruim 800 zakken (16 ton); daarboven is het een
       offertetraject, geen webshopbestelling.
       mmMax 40: gelijkgetrokken met het assortiment. De PDF geeft 350F en
       150F een laagdikte-range van 4-40 mm en 330 een range van 3-40 mm;
       40 mm is dus de dikste laag die één van de geadviseerde producten in
       één keer aankan. De oude grens van 60 mm adviseerde tussen 41 en 60 mm
       een product buiten zijn eigen bereik, en de bijbehorende melding
       ("boven 60 mm werk je in meerdere lagen") suggereerde bovendien dat
       60 mm in één laag mag. Keuze: verlagen in plaats van waarschuwen —
       een waarschuwing laat het foute aantal zakken staan, en dat aantal
       gaat hier één op één de winkelwagen in.
       invoerDecimalen 2: de formuletekst toont twee decimalen, dus slaan we
       ook op twee decimalen op — veld, formule en berekening rekenen zo
       gegarandeerd met hetzelfde getal. */
    m2Max: 2000,
    mmMax: 40,
    invoerDecimalen: 2,
    /* Standaard ingevulde laagdikte bij het egaliseren-pad (Jan, 9 sep), zodat
       het veld net als het m²-veld al gevuld is. 3 mm is bewust gekozen: het
       ligt ruim binnen de band van IKKO 220 (t/m 5 mm) en onder de grens waar
       randisolatie verplicht wordt (5 mm), dus een klein meetverschil kantelt
       het advies niet. Let op: dit veld bepaalt wél welk product eruit komt —
       anders dan het m²-veld, dat alleen het aantal zakken beïnvloedt.
       Pad C elektrisch krijgt geen 3 maar elektrischMinMm (5), anders zou de
       standaardwaarde meteen omhoog geklemd worden met een melding erbij. */
    mmStandaard: 3,
    /* Ondergrens per product, uit de PDF-begrippenlijst (330: 3-40 mm ·
       350F: 4-40 mm · 150F: 4-40 mm) en uit de producttitels waar de PDF geen
       range noemt (220 en 110G: 1-20 mm). Alleen de ondergrens staat hier:
       de bovengrenzen zijn onbereikbaar geworden nu mmMax op 40 staat en de
       beslisregels 220 op 5 mm en 110G op 15 mm afkappen. Onder de ondergrens
       klemmen we niet — de som klopt dan nog steeds, alleen het product is er
       niet voor gemaakt; daar hoort een melding bij, geen ander getal. */
    mmMin: { '220': 1, '330': 3, '350f': 4, '110g': 1, '150f': 4 },
    /* Verbruiksfactoren uit de PDF (Ikko_Egaline_Keuzelogica v2.9, 08-09-2026).
       Deze winnen bewust van het Shopify-metafield specs.verbruik_kg_m2_mm:
       de PDF corrigeert daar expliciet een fout metafield (150F stond op
       1,6 i.p.v. 1,8 kg/m²/mm, zie "150F (voorheen 150G)"). Zou het metafield
       voorgaan, dan kantelt één beheerderswijziging het advies stil.
       Producten zonder vastgelegde factor lezen wél uit het metafield. */
    verbruikVast: { '220': 1.6, '330': 1.66, '350f': 1.8, '110g': 1.66, '150f': 1.8 },
    /* Productnaam voor elke sleutel uit het datablock, voor het geval het
       product niet resolvet (DRAFT of van het Online Store-kanaal gehaald).
       Alle vijftien sleutels staan erin, niet alleen de vier drafts: zonder
       regel viel titelVan() terug op de sleutel zelf en kwam er "mixer" of
       "s500" in beeld — en in de WhatsApp-tekst naar de specialist.
       De vier drafts krijgen de volledige titel die ze straks in Shopify
       krijgen; de rest een korte productnaam die niet meebeweegt met een
       titelwijziging in de winkel (het echte producttitel-veld wint altijd,
       zie titelVan). kh-consistentie.js bewaakt dat elke sleutel uit
       snippets/keuzehulp-modal.liquid hier een regel heeft. */
    titelFallback: {
      '220': 'IKKO Level 220 Premium Egaline 20 kg',
      '330': 'IKKO Level 330 Egaline 20 kg',
      '350f': 'IKKO Level 350F Egaline 20 KG (4-40mm)',
      '110g': 'IKKO Level 110G Gipsgebonden Egaline 20 kg',
      '150f': 'IKKO Level 150F Egaline 20 KG (4-40mm)',
      'fill450s': 'IKKO Fill 450S – Uitvlakmortel voor Vloerverwarmingssleuven 20 KG',
      'fill410': 'IKKO Fill 410 – Uitvlakmortel voor Vloerverwarmingssleuven 20 KG',
      'nc118': 'UZIN NC 118 Uitvlakmortel gipsbasis 20 kg',
      's500': 'IKKO S500 Multigrund voorstrijk snel',
      's550': 'IKKO S550 Kontaktgrund voorstrijk',
      'randisolatie': 'Randisolatie met plakrand',
      'mixer': 'Lijm- en egalinemixer voor boorkop',
      'rakel': 'Egaliseerrakel Egaline Totaal 600 mm',
      'prikroller': 'Prikroller breedte 500 mm, pin 40 mm',
      'mengemmer': 'IKKO 30 liter mengemmer'
    },
    gereedschap: ['mixer', 'prikroller', 'rakel', 'mengemmer'],
    /* Korte namen voor de uitlegregel van de gereedschapsrij. De volledige
       producttitels zijn te lang voor één regel (ze liepen aaneengeregen over
       drie regels) en staan daarom in de aria-label van de rij; in de
       winkelwagen blijven het gewoon vier losse regels. */
    gereedschapKort: { mixer: 'mixer', prikroller: 'prikroller', rakel: 'rakel', mengemmer: 'mengemmer' },
    waarom: {
      'a-beton-220': 'Tot en met 5 mm op een cementgebonden ondergrond is IKKO 220 de standaard: fijn uitvlakken op een stabiele basis.',
      /* PDF-begrippenlijst bij IKKO 330: "ook geschikt voor
         vloerverwarmingsconstructies (laagdikte-range 3–40 mm), maar niet in
         permanent vochtige ruimtes en zonder letterlijke ingiet-claim". Alleen
         de eerste helft noemen zou de bron eenzijdig weergeven — maar alleen
         de beperking noemen laat de klant in een badkamer met een advies
         zitten waar hij niets mee kan: dit pad stelt bewust geen vochtvraag
         (Robbin: vocht sluit cementgebonden nooit uit) en kent dus geen
         alternatief. De PDF geeft dat alternatief zelf wel: 350F is voor deze
         groep "ook het vaste product in vochtige ruimtes, ongeacht
         laagdikte". Die uitweg staat er daarom bij. */
      'a-beton-330': 'Voor lagen van 5 tot 25 mm op een cementgebonden ondergrond is IKKO 330 het vaste product; over vloerverwarming heen mag het ook. Twee uitzonderingen: het verwarmingssysteem zelf ingieten, en een permanent natte ruimte zoals een doucheruimte — daar adviseren we IKKO 350F uit dezelfde lijn. App ons even als je vloer onder een van die twee valt.',
      'a-beton-350f': 'Boven 25 mm adviseren we IKKO 350F: cementgebonden en gemaakt voor dikke lagen, ook in vochtige ruimtes.',
      'a-gips-vocht': 'Gips hoort niet in een vochtige ruimte. IKKO 350F is cementgebonden en kan daar wel tegen — daarom is dit hier het advies, ongeacht laagdikte.',
      /* De producttitel op dezelfde kaart noemt het bereik van 110G (1-20 mm);
         "dekt lagen tot en met 15 mm" las daardoor als een tegenspraak op één
         scherm. De 15 mm uit de PDF is onze adviesgrens, niet de bovengrens
         van het product: zo geformuleerd blijft de PDF leidend zonder dat het
         scherm zichzelf tegenspreekt. */
      'a-gips-110g': 'Op een gipsgebonden ondergrond hecht een gipsgebonden egaline het best. Tot en met 15 mm adviseren we IKKO 110G; daarboven stappen we over op IKKO 150F.',
      'a-gips-150f': 'Boven 15 mm op een gipsgebonden ondergrond is IKKO 150F de keuze: gipsgebonden en geschikt van 4 tot 40 mm.',
      'a-hout-vocht': 'Bij vocht valt de gipsgebonden voorkeur af: IKKO 350F is cementgebonden en vochtbestendig.',
      'a-hout-droog': 'Op hout, plaatmateriaal of een onzekere ondergrond is IKKO 150F de voorkeur, ongeacht laagdikte — met IKKO S550 als hechtbrug eronder.',
      'b-450s': 'Je wilt dezelfde dag nog egaliseren: IKKO Fill 450S verhardt snel genoeg om direct door te kunnen.',
      'b-410': 'Geen haast met egaliseren: IKKO Fill 410 heeft een langere verwerkingstijd, dus meer tijd om de sleuven rustig te vullen.',
      'b-nc118': 'Voor sleuven in een gips- of anhydrietvloer is UZIN NC 118 het vaste product — een snel/langzaam-keuze is hier niet nodig.',
      'c-vocht': 'In een vochtige ruimte valt de gipsgebonden 150F af: IKKO 350F is cementgebonden en heeft een expliciete claim voor het ingieten van vloerverwarming, ook in natte ruimtes.',
      'c-droog': 'Voor een droge ruimte is IKKO 150F zeer geschikt: gipsgebonden en gemaakt voor opbouwvloerverwarming.'
    },
    waarschuwingGips: 'Gips hoort niet in een vochtige ruimte. We adviseren daarom de cementgebonden IKKO 350F, ongeacht laagdikte. Twijfel je over de opbouw?',
    vochtContext: {
      'a-gips': 'Gips kan niet tegen langdurig vocht — dit bepaalt welk product we adviseren.',
      'a-hout': 'Bij vocht adviseren we een cementgebonden egaline in plaats van de gipsgebonden voorkeur.',
      c: 'De gipsgebonden variant kan niet tegen vocht — dit bepaalt welke egaline we ingieten.'
    },
    /* Eén regel per extra-rij: de kern blijft staan, de toelichting eromheen
       niet ("voor een gelijkmatige hechting" / "en kritische ondergronden"). */
    voorstrijkDesc: {
      s500: 'zuigende vloer voorstrijken',
      s550: 'hechtbrug voor hout en plaatmateriaal'
    },
    /* Twee routes waarin de modal niets afrekent maar doorverwijst naar de
       specialist. De weergave is identiek (geen totaal, geen toggles, geen
       levertijdbelofte, WhatsApp als primaire knop); alleen de reden en de
       teksten verschillen.
       - nvt: het product staat nog niet online (DRAFT).
       - uitverkocht: het hoofdproduct heeft beschikbaar === false. Dan is er
         geen enkele variant te koop en weigert /cart/add.js de hele aanvraag;
         "In winkelwagen" met een totaal eronder is dan een knop die gegarandeerd
         faalt. De productpagina doet in dezelfde situatie hetzelfde: de
         koopknop krijgt daar class "sold-out" + disabled en het label
         products.product.sold_out (snippets/product-add-to-cart.liquid).
       De palletroute (prijs op aanvraag vanaf staffel.pallet_min) is op
       21-09-2026 vervallen: grote aantallen gaan gewoon in de winkelwagen
       tegen de prijs van de hoogste trede, net als op de productpagina. */
    route: {
      nvt: {
        knop: 'Bestel via WhatsApp',
        voet: 'Dit advies staat nog niet online in de webshop. Stuur het via WhatsApp — inclusief de onderdelen hierboven — dan zetten we je bestelling klaar.',
        prijsNoot: 'Bestellen kan alvast via WhatsApp',
        waSlot: 'Dit product is nog niet online bestelbaar — kunnen jullie me verder helpen?',
        rijReden: 'gaat mee in je bericht aan de specialist'
      },
      uitverkocht: {
        knop: 'Vraag levertijd aan',
        voet: 'Dit product staat nu op uitverkocht, dus we kunnen het niet in de winkelwagen leggen. Stuur je advies via WhatsApp — inclusief de onderdelen hierboven — dan zoeken we de levertijd voor je uit.',
        prijsNoot: 'Tijdelijk uitverkocht: levertijd op aanvraag',
        waSlot: 'Dit product staat online op uitverkocht — kunnen jullie mij de levertijd doorgeven?',
        rijReden: 'gaat mee in je bericht aan de specialist'
      }
    }
  };

  /* Labels voor recap-chips en samenvattingen */
  var LABELS = {
    doel: { egaliseren: 'Egaliseren', sleuven: 'Sleuven dichtzetten', ingieten: 'Vloerverwarming ingieten' },
    groep: { 'beton-cement': 'Beton of cement', gips: 'Gips of anhydriet', hout: 'Hout, plaat of twijfel' },
    groepZin: { 'beton-cement': 'beton of cement', gips: 'gips of anhydriet', hout: 'hout of plaatmateriaal' },
    vocht: { ja: 'Vochtige ruimte', nee: 'Droge ruimte', 'weet-niet': 'Vocht: weet ik niet' },
    bOndergrond: { cement: 'Cementbasis', gips: 'Gips of anhydriet' },
    bOndergrondZin: { cement: 'een cementbasis', gips: 'gips of anhydriet' },
    bZelfdeDag: { ja: 'Zelfde dag egaliseren', nee: 'Niet dezelfde dag' },
    cSysteem: { noppenplaat: 'Noppenplaat', klemrail: 'Klemrailsysteem', tacker: 'Tackersysteem', elektrisch: 'Elektrische vloerverwarming' },
    cSysteemZin: { noppenplaat: 'een noppenplaatsysteem', klemrail: 'een klemrailsysteem', tacker: 'een tackersysteem', elektrisch: 'elektrische vloerverwarming' }
  };

  /* Legacy-prefills (oude data-ondergrond-waarden, o.a. opgeslagen secties) */
  var LEGACY_REMAP = {
    zandcement: { doel: 'egaliseren', groep: 'beton-cement' },
    'tegels-beton': { doel: 'egaliseren', groep: 'beton-cement' },
    anhydriet: { doel: 'egaliseren', groep: 'gips' },
    hout: { doel: 'egaliseren', groep: 'hout' },
    onbekend: { doel: 'egaliseren', groep: 'hout' }
  };

  var CHECK_SVG = '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6.5L4.8 9.2 10 3.2"/></svg>';

  /* ===== State ===== */
  var state = { doel: null, groep: null, vocht: null, bOndergrond: null, bZelfdeDag: null, cSysteem: null, mm: null, m2: 35 };
  var huidigeStap = 'doel';
  var extras = { voorstrijk: true, rand: true, tools: false };
  /* Samenstelling van het advies waar de huidige extras-keuzes bij horen;
     zolang die gelijk blijft, houden we de keuzes van de klant vast. */
  var extrasVoorSamenstelling = null;
  var invoerMelding = { m2: null, mm: null };
  var lastTrigger = null;
  var huidigAdvies = null;
  /* Staat het getoonde advies in een adviesroute (nvt of uitverkocht)? Dan valt er
     niets af te rekenen en is de winkelwagenknop verborgen; zetInWinkelwagen
     gebruikt dit als tweede slot. */
  var huidigViaAdvies = false;
  var resBedragen = { hoofd: 0, voorstrijk: 0, rand: 0, tools: 0 };

  /* ===== Helpers ===== */
  /* Geen euroteken: de winkel staat op moneyFormat
     "{{amount_with_comma_separator}}", dus alles wat Liquid rendert komt zonder
     symbool. Jan (11-09-2026): euroteken mag overal weg. */
  function fmt(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  /* Nederlandse notatie voor alle getallen in de UI: komma als decimaalteken,
     maximaal twee decimalen, geen overbodige nullen (12,5 / 1,66 / 35).
     Niet-numerieke waarden (bv. een tekstueel metafield) blijven ongemoeid. */
  function decimaal(n) {
    var num = Number(n);
    if (n === null || n === '' || !isFinite(num)) return String(n);
    return String(Math.round(num * 100) / 100).replace('.', ',');
  }
  /* Afronden op de invoerprecisie: het veld, de formuletekst en de
     zakkenberekening moeten met exact hetzelfde getal werken. */
  function rondInvoer(v) {
    var f = Math.pow(10, KH_CONFIG.invoerDecimalen);
    return Math.round(v * f) / f;
  }
  /* Nederlands duizendtalpatroon: 1 tot 3 cijfers (niet met een nul beginnend),
     daarna een of meer groepen van precies drie cijfers, en verder niets.
     "1.000" - "1.250" - "1.000.000" passen; "12.5", "12.55" en "0.500" niet. */
  var DUIZENDTAL = /^[1-9]\d{0,2}(\.\d{3})+$/;
  /* Beide invoervelden zijn type="text" met inputmode="decimal". Een
     type="number"-veld maakt .value leeg zodra de inhoud geen geldig
     floating-point getal is: op een Nederlands toetsenbord kwam "12,5" dan
     als lege string binnen en bleef de adviesknop grijs terwijl het veld
     12,5 toonde. We normaliseren daarom zelf.
     De regel, expliciet, want punt en komma betekenen hier niet hetzelfde:
     1. spaties en harde spaties eruit;
     2. staat er een komma in, dan is de komma het decimaalteken en is elke
        punt een duizendtalpunt: punten weg, komma wordt punt
        ("1.234,5" -> 1234,5);
     3. zonder komma is een punt alleen een duizendtalpunt als het hele getal
        het Nederlandse duizendtalpatroon volgt (DUIZENDTAL): "1.000" -> 1000,
        "1.250" -> 1250. Elke andere punt blijft het decimaalteken:
        "12.5" -> 12,5 - "12.55" -> 12,55 - "0.500" -> 0,5.
     Zonder regel 3 las "1.000" als 1 en "1.250" als 1,25, stil: parseFloat
     kapt gewoon af bij de punt. De prijs van de regel is dat "12.500" als
     12500 leest en niet als 12,5 - dat is de Nederlandse lezing van dat
     getal, en bij het verlaten van het veld schrijven we terug waarmee we
     rekenen, dus de klant ziet welk getal het geworden is.
     Niet-numerieke invoer geeft null (nooit NaN in de UI). */
  function leesGetal(el) {
    var ruw = String(el.value == null ? '' : el.value).replace(/[\s\u00a0]/g, '');
    if (ruw === '') return null;
    if (ruw.indexOf(',') > -1) {
      ruw = ruw.replace(/\./g, '').replace(',', '.');
    } else if (DUIZENDTAL.test(ruw)) {
      ruw = ruw.replace(/\./g, '');
    }
    var v = parseFloat(ruw);
    return isFinite(v) ? rondInvoer(v) : null;
  }
  /* Meldingen bij invoer die we niet één op één overnemen. */
  var INVOER_TEKST = {
    m2: {
      onzin: 'Vul je oppervlakte in cijfers in, bijvoorbeeld 35 of 12,5.',
      max: 'We rekenen online tot ' + decimaal(KH_CONFIG.m2Max) + ' m²; voor een grotere vloer maken we een offerte. Hieronder rekenen we met ' + decimaal(KH_CONFIG.m2Max) + ' m².'
    },
    mm: {
      onzin: 'Vul je laagdikte in cijfers in, bijvoorbeeld 8 of 12,5.',
      /* Noemt de reden van de grens (het productbereik), niet alleen het
         getal: de oude tekst zette de grens op 60 mm en las alsof 60 mm in
         één laag mag. */
      max: 'Onze egalines gaan tot ' + decimaal(KH_CONFIG.mmMax) + ' mm in één laag. Dikker betekent in meerdere lagen werken — overleg dat even met een specialist. Hieronder rekenen we met ' + decimaal(KH_CONFIG.mmMax) + ' mm.'
    }
  };
  /* Leest een invoerveld en klemt het op de bovengrens uit KH_CONFIG.
     Geeft {waarde, melding}: waarde null bij leeg, 0, negatief of onzin. */
  function leesVeld(el, max, teksten) {
    var leeg = String(el.value == null ? '' : el.value).trim() === '';
    var v = leesGetal(el);
    if (v === null) return { waarde: null, melding: leeg ? null : teksten.onzin };
    if (v <= 0) return { waarde: null, melding: null };
    if (v > max) return { waarde: max, melding: teksten.max };
    return { waarde: v, melding: null };
  }
  function zakLabel(n) {
    return n + (n === 1 ? ' zak' : ' zakken');
  }
  /* Formuletekst voor de laagdikte-paden (A en C-elektrisch). De eenheid staat
     voluit: de PDF schrijft consequent kg/m²/mm en de PDP-calculator van het
     thema zegt "kg per m² per mm". Alleen "kg" achter de factor las als een
     gewicht, en botste met de C-formule "35 m² × 34 kg/m²" op hetzelfde scherm. */
  function formuleLaagdikte(m2Tekst, mm, factor) {
    return m2Tekst + ' m² × ' + decimaal(mm) + ' mm × ' + decimaal(factor) + ' kg/m²/mm';
  }
  function product(key) {
    return PRODUCTEN[key] || null;
  }
  /* Eén definitie van "dit kan de winkelwagen in": het product bestaat én de
     variant is te koop. Het datablock kent alleen variant.available, dus dit
     zegt niets over de geadviseerde hoeveelheid — wel over de vraag of
     /cart/add.js de regel überhaupt accepteert. Dezelfde functie bepaalt de
     kaartweergave, het totaal én wat er wordt meegestuurd; anders kan het
     scherm iets tonen wat de cart-add daarna alsnog laat mislukken. */
  function bestelbaar(key) {
    var p = product(key);
    return !!p && p.beschikbaar !== false;
  }
  /* Alleen de gereedschappen die vandaag te bestellen zijn. /cart/add.js
     weigert de héle aanvraag zodra één regel niet leverbaar is, dus een set
     met een uitverkocht deel erin liet de complete bestelling mislukken.
     De kaart heet naar het aantal delen dat er echt in zit; de badge "Niet
     compleet op voorraad" legt uit waarom dat er minder kunnen zijn. */
  function toolsTeBestellen(advies) {
    return advies.gereedschap.filter(bestelbaar);
  }
  /* Staffeltredes van een product, oplopend op minimum aantal. Het datablock
     (snippets/keuzehulp-modal.liquid) levert ze al in die volgorde en laat
     lege of nul-prijzen weg, maar we zeven en sorteren hier nog een keer: de
     volgorde van twee losse metaveldparen is geen garantie, en "hoogste trede
     die het aantal haalt" is alleen juist als de lijst echt oplopend is.
     Ontbreekt het veld (oude gecachete pagina, ander datablock), dan is het
     antwoord een lege lijst en niet een fout. */
  function staffelTredes(p) {
    if (!p || !p.staffel || !p.staffel.length) return [];
    return p.staffel
      .filter(function (t) { return t && t.min > 0 && t.prijs > 0; })
      .sort(function (a, b) { return a.min - b.min; });
  }
  /* Wordt de staffel van dít product automatisch verrekend in de winkelwagen?
     Per product uit het datablock (vendor == 'IKKO' = de set waarvoor de 16
     automatische kortingen bestaan, actief vanaf di 15-09-2026 15:00). Zie de
     comment boven KH_CONFIG en snippets/keuzehulp-modal.liquid. */
  function staffelAuto(p) {
    return !!(p && p.staffelAuto);
  }
  /* De trede waar dit aantal in valt: de hoogste die het haalt. Bij 60 zakken
     is dat trede 50-99 en niet trede 25-49 — met één drempel viel dat verschil
     nog samen, met drie tredes niet meer. Geen enkele trede gehaald -> null. */
  function staffelTrede(tredes, aantal) {
    var gevonden = null;
    tredes.forEach(function (t) {
      if (aantal >= t.min) gevonden = t;
    });
    return gevonden;
  }
  /* Boven dit aantal zakken vervalt de levertijdbelofte. Een gewichtsgrens,
     los van de staffel: de PDP belooft "volgende werkdag geleverd (ook per pallet)", dus één
     volle pallet is gedekt; daarboven (meerdere pallets) beloven we niets.
     Eén pallet zakgoed is ±1.000 kg = 50 zakken van 20 kg. We trekken hier
     alleen een belofte in, we doen er geen. */
  var BULK_VANAF = Math.ceil(1000 / KH_CONFIG.zakKg);
  function titelVan(key) {
    var p = product(key);
    return p ? p.titel : (KH_CONFIG.titelFallback[key] || key);
  }
  /* Volgorde bewust: eerst de vastgelegde PDF-factor, pas daarna het
     metafield (zie KH_CONFIG.verbruikVast voor de reden). */
  function verbruikVan(key) {
    if (Object.prototype.hasOwnProperty.call(KH_CONFIG.verbruikVast, key)) return KH_CONFIG.verbruikVast[key];
    var p = product(key);
    var mf = p ? Number(p.verbruik) : NaN;
    return (isFinite(mf) && mf > 0) ? mf : 1.8;
  }
  /* Omtrek schatten uit het oppervlak: bij gelijk oppervlak heeft een
     vierkante ruimte de kortste omtrek (4 x wortel(m²)), dus dit is de
     ondergrens — elke andere vorm (L-vorm, gang) is langer. Daarom ronden
     we het aantal rollen naar boven af en vragen we de klant zijn eigen
     omtrek na te meten. */
  function randOmtrek(m2) {
    return 4 * Math.sqrt(m2);
  }
  function randRollen(m2) {
    return Math.max(1, Math.ceil(randOmtrek(m2) / KH_CONFIG.randRolMeter));
  }
  /* Laagdikte onder de ondergrens van het geadviseerde product (KH_CONFIG.mmMin):
     de berekening klopt dan nog steeds, maar het product is er niet voor
     opgegeven — bij 0,5 mm rolde er een advies voor IKKO 220 uit terwijl de
     eigen producttitel bij 1 mm begint. We rekenen door met de opgave van de
     klant en zetten er één melding bij; klemmen zou hier stilletjes méér
     materiaal bestellen dan gevraagd. */
  function bereikNoot(key, mm) {
    var min = KH_CONFIG.mmMin[key];
    if (!min || !mm || mm >= min) return null;
    return 'Let op: ' + titelVan(key) + ' is opgegeven vanaf ' + decimaal(min) + ' mm laagdikte en jij vult ' +
      decimaal(mm) + ' mm in. We rekenen met jouw opgave — leg zo\'n dunne laag even voor aan een specialist.';
  }
  /* Zelfde grens als de mobiele media query in assets/et-keuzehulp.css (640 px).
     Wordt alleen gebruikt om te bepalen of het stookprotocol opengeklapt start;
     alles wat met de layout te maken heeft blijft in de CSS staan. */
  function isSmalScherm() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 640px)').matches;
  }
  function mmNodig() {
    return state.doel === 'egaliseren' || (state.doel === 'ingieten' && state.cSysteem === 'elektrisch');
  }
  function isVochtig() {
    return state.vocht === 'ja' || state.vocht === 'weet-niet';
  }

  /* ===== Sequence-engine: panel-id-reeks per pad ===== */
  function bepaalStappen(s) {
    if (!s.doel) return ['doel'];
    var seq = ['doel'];
    if (s.doel === 'egaliseren') {
      seq.push('a-ondergrond');
      if (s.groep === 'gips' || s.groep === 'hout') seq.push('vocht');
    } else if (s.doel === 'sleuven') {
      seq.push('b-ondergrond');
      if (s.bOndergrond === 'cement') seq.push('b-zelfdedag');
    } else {
      /* Jan, 9 sep: de afwerkingsvraag vervalt in pad C; de vochtvraag komt er
         onvoorwaardelijk voor in de plaats. Afwijking van PDF v2.9, die
         tegels/natuursteen altijd op 350F zette ongeacht vocht — voorgelegd. */
      seq.push('c-systeem', 'vocht');
    }
    seq.push('invoer');
    return seq;
  }
  function stapGeldig(id) {
    switch (id) {
      case 'doel': return !!state.doel;
      case 'a-ondergrond': return !!state.groep;
      case 'vocht': return !!state.vocht;
      case 'b-ondergrond': return !!state.bOndergrond;
      case 'b-zelfdedag': return !!state.bZelfdeDag;
      case 'c-systeem': return !!state.cSysteem;
      case 'invoer':
        /* Elke waarde groter dan 0 telt: een dorpel van 0,5 m² of een laag
           van 0,5 mm is een echte klus. 0, leeg en onzin blijven ongeldig
           (leesGetal geeft daar null/0 op terug). */
        if (!state.m2 || state.m2 <= 0) return false;
        if (!mmNodig()) return true;
        return !!state.mm && state.mm > 0; /* pad C elektrisch: < 5 mm clampt naar 5 */
      default: return false;
    }
  }
  function eersteOnbeantwoorde(seq) {
    for (var i = 0; i < seq.length; i++) {
      if (!stapGeldig(seq[i])) return seq[i];
    }
    return seq[seq.length - 1];
  }

  /* ===== Beslisregels (bindend, PDF v2.9) ===== */
  function resolveAdvies(s) {
    if (!s.doel || !s.m2 || s.m2 <= 0) return null;
    var adv = {
      hoofd: null,
      voorstrijk: null,
      randisolatie: false,
      randRollen: 0,
      gereedschap: KH_CONFIG.gereedschap.slice(),
      waarschuwing: null,
      stookprotocol: false,
      waarom: '',
      rekenMm: null,   /* laagdikte waarmee gerekend is; null bij de vaste systeemcijfers */
      rekenNoot: null, /* uitleg als die afwijkt van de invoer (elektrisch onder 5 mm) */
      bereikNoot: null /* melding als de laagdikte onder het bereik van het product ligt */
    };
    var m2 = s.m2;
    var m2Tekst = decimaal(m2); /* formuletekst toont hetzelfde getal als het veld */
    var vochtig = s.vocht === 'ja' || s.vocht === 'weet-niet';
    var key, zakken;

    if (s.doel === 'egaliseren') {
      if (!s.groep) return null;
      var mm = s.mm;
      if (!mm || mm <= 0) return null;
      var voorstrijkKey = 's500';
      var waaromKey;
      if (s.groep === 'beton-cement') {
        /* Geen vochtvraag: vocht sluit cementgebonden nooit uit (Robbin 08-09) */
        key = mm <= 5 ? '220' : (mm <= 25 ? '330' : '350f');
        waaromKey = 'a-beton-' + key;
      } else if (s.groep === 'gips') {
        if (!s.vocht) return null;
        if (vochtig) {
          key = '350f';
          waaromKey = 'a-gips-vocht';
          adv.waarschuwing = KH_CONFIG.waarschuwingGips;
        } else {
          key = mm <= 15 ? '110g' : '150f';
          waaromKey = 'a-gips-' + key;
        }
      } else {
        if (!s.vocht) return null;
        /* TE BEVESTIGEN AANNAME (spec r66, gemeld in de oplevering).
           De PDF-figuur zet IKKO S550 op de groepkolom "hout / plaatmateriaal /
           kritisch" — dus voor de hele groep, ook bij vocht. In de tabel
           eronder staat bij "Vochtige ruimte" echter "350F (S500-lijn)": dat
           kan de egalinelijn bedoelen (350F hoort bij de S500-lijn) of ook de
           voorstrijk. De begrippenlijst bevestigt S550 juist als veilige
           default voor deze groep, ook bij twijfel over de ondergrond.
           De code houdt daarom S550 aan voor de hele groep — één product per
           groep, zoals de figuur het tekent. Wijkt Robbin hiervan af, dan is
           dit de enige regel die verandert. De klant krijgt hier bewust geen
           slag om de arm te zien: dit is een vraag tussen ons en de
           leverancier, geen twijfel om bij de klant neer te leggen. */
        voorstrijkKey = 's550';
        key = vochtig ? '350f' : '150f';
        waaromKey = vochtig ? 'a-hout-vocht' : 'a-hout-droog';
      }
      var factor = verbruikVan(key);
      zakken = Math.max(1, Math.ceil(mm * m2 * factor / KH_CONFIG.zakKg));
      adv.hoofd = { key: key, qty: zakken, formuleTekst: formuleLaagdikte(m2Tekst, mm, factor) };
      adv.rekenMm = mm;
      adv.bereikNoot = bereikNoot(key, mm);
      adv.voorstrijk = { key: voorstrijkKey, qty: Math.max(1, Math.ceil(m2 / KH_CONFIG.voorstrijkM2PerCan)) };
      adv.randisolatie = mm >= 5; /* exact 5 mm telt mee */
      adv.randRollen = adv.randisolatie ? randRollen(m2) : 0;
      adv.waarom = KH_CONFIG.waarom[waaromKey];
      return adv;
    }

    if (s.doel === 'sleuven') {
      if (!s.bOndergrond) return null;
      var waaromKeyB;
      if (s.bOndergrond === 'cement') {
        if (!s.bZelfdeDag) return null;
        key = s.bZelfdeDag === 'ja' ? 'fill450s' : 'fill410';
        waaromKeyB = s.bZelfdeDag === 'ja' ? 'b-450s' : 'b-410';
      } else {
        key = 'nc118';
        waaromKeyB = 'b-nc118';
      }
      zakken = Math.max(1, Math.ceil(m2 / KH_CONFIG.sleuvenM2PerZak));
      adv.hoofd = { key: key, qty: zakken, formuleTekst: m2Tekst + ' m² ÷ ' + KH_CONFIG.sleuvenM2PerZak + ' m² per zak' };
      adv.voorstrijk = { key: 's500', qty: Math.max(1, Math.ceil(m2 / KH_CONFIG.voorstrijkM2PerCan)) };
      adv.waarom = KH_CONFIG.waarom[waaromKeyB];
      return adv;
    }

    /* Pad C: ingieten — geen voorstrijk, altijd randisolatie + stookprotocol */
    if (!s.cSysteem || !s.vocht) return null;
    var waaromKeyC = vochtig ? 'c-vocht' : 'c-droog';
    key = vochtig ? '350f' : '150f';
    var formule;
    if (s.cSysteem === 'elektrisch') {
      var mmC = s.mm;
      if (!mmC || mmC <= 0) return null;
      var rekenMm = Math.max(KH_CONFIG.elektrischMinMm, mmC);
      var factorC = verbruikVan(key);
      zakken = Math.max(1, Math.ceil(rekenMm * m2 * factorC / KH_CONFIG.zakKg));
      formule = formuleLaagdikte(m2Tekst, rekenMm, factorC);
      /* De klem is de enige plek waar we met een ander getal rekenen dan de
         klant invoerde. Zonder deze regel verdween dat uit beeld zodra het
         hoofdproduct bestelbaar is: het resultaat toonde dan alleen zakken. */
      adv.rekenMm = rekenMm;
      if (rekenMm !== mmC) {
        adv.rekenNoot = 'We rekenen met ' + decimaal(rekenMm) + ' mm: onder elektrische vloerverwarming is ' +
          decimaal(KH_CONFIG.elektrischMinMm) + ' mm dekking het minimum. Je gaf ' + decimaal(mmC) + ' mm op.';
      }
    } else {
      var kg = KH_CONFIG.kgPerM2[s.cSysteem];
      zakken = Math.max(1, Math.ceil(m2 * kg / KH_CONFIG.zakKg));
      formule = m2Tekst + ' m² × ' + kg + ' kg/m²';
    }
    adv.hoofd = { key: key, qty: zakken, formuleTekst: formule };
    adv.randisolatie = true;
    adv.randRollen = randRollen(m2);
    adv.stookprotocol = true;
    adv.waarom = KH_CONFIG.waarom[waaromKeyC];
    return adv;
  }

  /* ===== Views ===== */
  function toonView(naam) {
    huidigeView = naam;
    vragen.hidden = naam !== 'vragen';
    resultaat.hidden = naam !== 'resultaat';
    specialist.hidden = naam !== 'specialist';
    modal.classList.toggle('et-kh-modal--wide', naam === 'resultaat');
    modal.classList.toggle('et-kh-modal--narrow', naam === 'specialist');
    modal.scrollTop = 0;
  }
  /* Focus-trap: eenvoudige Tab-cycling binnen de open modal. Verzamelen bij
     openen; in de Tab-handler verversen we de lijst (views en panelen
     wisselen binnen een sessie) en filteren we op zichtbaarheid. */
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var focusLijst = [];
  function verzamelFocusables() {
    focusLijst = Array.prototype.filter.call(
      modal.querySelectorAll(FOCUSABLE_SELECTOR),
      function (el) { return el.offsetParent !== null; }
    );
    return focusLijst;
  }
  /* Keuze (fix): de modal opent áltijd op de vragen-view die bij de huidige
     state hoort. Resultaat en specialist zijn uitkomsten van een klik ("Toon
     mijn advies"), geen toestand om naar terug te keren; zonder dit opende een
     plain [data-keuzehulp-open]-trigger opnieuw op het oude advies. De
     antwoorden blijven wél staan, dus de gebruiker landt op de stap waar hij
     gebleven was (na een advies: de invoer-stap). Prefill en data-kh-start
     zetten huidigeStap vóór openModal en blijven daarom intact; renderStap
     valt zelf terug op de eerste onbeantwoorde stap als huidigeStap niet meer
     in de reeks past. Reset hier en niet in closeModal, anders zie je tijdens
     het sluiten nog een frame van de vragen-view. */
  function openModal(trigger) {
    lastTrigger = trigger || null;
    meetStart(trigger);
    toonView('vragen');
    renderStap();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    verzamelFocusables();
    modal.focus();
  }
  function closeModal() {
    if (!overlay.hidden) meetSluit();
    overlay.hidden = true;
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  /* ===== Stappen renderen ===== */
  function renderStap() {
    var seq = bepaalStappen(state);
    var idx = seq.indexOf(huidigeStap);
    if (idx === -1) {
      huidigeStap = eersteOnbeantwoorde(seq);
      idx = seq.indexOf(huidigeStap);
    }
    vragen.querySelectorAll('[data-step-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-step-panel') !== huidigeStap;
    });
    /* Zolang het doel niet gekozen is, is de reeks alleen ['doel'] en zou de
       teller "Stap 1 van 1" boven een volgelopen balk zetten — terwijl elk pad
       daarna 3, 4 of 5 stappen telt. We tonen dan geen totaal (teller verborgen
       op desktop én mobiel) en zetten de balk in een neutrale beginstand: één
       lege baan, niets gevuld. */
    var padBekend = !!state.doel;
    vragen.querySelectorAll('[data-stepcounter]').forEach(function (el) { el.hidden = !padBekend; });
    vragen.querySelectorAll('[data-stepnum]').forEach(function (el) { el.textContent = String(idx + 1); });
    vragen.querySelectorAll('[data-steptotal]').forEach(function (el) { el.textContent = String(seq.length); });
    var bar = document.getElementById('et-kh-progress');
    var html = '';
    if (padBekend) {
      for (var i = 0; i < seq.length; i++) {
        html += '<span' + (i <= idx ? ' class="is-done"' : '') + '></span>';
      }
    } else {
      html = '<span></span>';
    }
    bar.innerHTML = html;
    var pos = idx === 0 ? 'first' : (idx === seq.length - 1 ? 'last' : 'mid');
    vragen.setAttribute('data-pos', pos);
    if (huidigeStap === 'vocht') renderVochtContext();
    if (huidigeStap === 'invoer') renderInvoer();
    renderFooterGeldig();
  }
  function renderFooterGeldig() {
    var geldig = stapGeldig(huidigeStap);
    document.getElementById('et-kh-next').disabled = !geldig;
    document.getElementById('et-kh-advies').disabled = !geldig;
  }
  function gaNaarStap(id) {
    huidigeStap = id;
    toonView('vragen');
    renderStap();
  }
  function volgende() {
    if (!stapGeldig(huidigeStap)) return;
    var seq = bepaalStappen(state);
    var idx = seq.indexOf(huidigeStap);
    if (idx > -1 && idx < seq.length - 1) gaNaarStap(seq[idx + 1]);
  }
  function vorige() {
    var seq = bepaalStappen(state);
    var idx = seq.indexOf(huidigeStap);
    if (idx > 0) gaNaarStap(seq[idx - 1]);
  }

  /* ===== Antwoorden ===== */
  function zetMm(v) {
    state.mm = v;
    invoerMelding.mm = null;
    var el = document.getElementById('et-kh-mm');
    if (el) el.value = v === null ? '' : decimaal(v);
  }
  /* Wist alle padspecifieke antwoorden; het ingevulde oppervlak blijft staan
     (spec: doel-wissel behoudt m²). */
  function wisPadAntwoorden() {
    state.groep = null;
    state.vocht = null;
    state.bOndergrond = null;
    state.bZelfdeDag = null;
    state.cSysteem = null;
    zetMm(null);
  }
  function zetAntwoord(key, val) {
    if (state[key] === val) return;
    state[key] = val;
    if (val !== null) meet('antwoord', { stap: key, waarde: val });
    if (key === 'doel') wisPadAntwoorden();
    if (key === 'groep') state.vocht = null;
    if (key === 'bOndergrond') state.bZelfdeDag = null;
    renderKaarten();
    renderStap();
  }
  function renderKaarten() {
    overlay.querySelectorAll('[data-answer]').forEach(function (btn) {
      var key = btn.getAttribute('data-answer');
      btn.setAttribute('aria-pressed', state[key] === btn.getAttribute('data-value') ? 'true' : 'false');
    });
  }
  overlay.querySelectorAll('[data-answer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-answer');
      var val = btn.getAttribute('data-value');
      zetAntwoord(key, state[key] === val ? null : val); /* nogmaals klikken = deselecteren */
    });
  });

  /* ===== Vocht-context ===== */
  function renderVochtContext() {
    var ctx = state.doel === 'egaliseren'
      ? (state.groep === 'gips' ? 'a-gips' : 'a-hout')
      : 'c';
    document.getElementById('et-kh-vocht-sub').textContent = KH_CONFIG.vochtContext[ctx] || '';
  }

  /* ===== Invoer-stap: m2 + mm + verbruik-preview + recap ===== */
  var m2Input = document.getElementById('et-kh-m2');
  var mmInput = document.getElementById('et-kh-mm');
  m2Input.addEventListener('input', function () {
    var r = leesVeld(m2Input, KH_CONFIG.m2Max, INVOER_TEKST.m2);
    state.m2 = r.waarde === null ? 0 : r.waarde;
    invoerMelding.m2 = r.melding;
    renderInvoerDynamisch();
  });
  mmInput.addEventListener('input', function () {
    var r = leesVeld(mmInput, KH_CONFIG.mmMax, INVOER_TEKST.mm);
    state.mm = r.waarde;
    invoerMelding.mm = r.melding;
    renderInvoerDynamisch();
  });
  /* Bij het verlaten van het veld schrijven we de verwerkte waarde terug: wat
     je ziet is dan exact waarmee we rekenen (12.5 -> 12,5 · 10,004 -> 10 ·
     3000 -> 2000). Tijdens het typen doen we dat bewust niet — dan kun je
     geen decimaal meer intypen en vecht je met de klem bij elke toetsaanslag. */
  function normaliseerVeld(el, waarde, veld) {
    if (String(el.value == null ? '' : el.value).trim() === '') return;
    el.value = (waarde && waarde > 0) ? decimaal(waarde) : '';
    if (el.value === '') invoerMelding[veld] = null;
    renderInvoerDynamisch();
  }
  m2Input.addEventListener('change', function () { normaliseerVeld(m2Input, state.m2, 'm2'); });
  mmInput.addEventListener('change', function () { normaliseerVeld(mmInput, state.mm, 'mm'); });
  /* ===== Live regions =====
     Twee soorten meldingen, twee behandelingen.
     1. De invoermeldingen (#et-kh-invoer-limiet en #et-kh-invoer-note) zijn
        zelf role="status". Ze mogen daarom niet met het hidden-attribuut
        verdwijnen: display:none haalt ze uit de toegankelijkheidsboom en dan
        mist een schermlezer de wijziging. Leeg = klasse is-leeg (clip), zodat
        ze in de boom blijven staan en aria-describedby op de velden blijft
        kloppen.
     2. De verbruikuitkomst staat verspreid over drie zichtbare vakjes en
        verandert bij elke toetsaanslag. Die melden we als één zin in de
        aparte, altijd aanwezige status-regio #et-kh-verbruik-live, vertraagd
        tot de gebruiker even ophoudt met typen.
     Beide zijn status (polite), niet alert: dit is feedback tijdens het typen
     en mag de gebruiker niet onderbreken. */
  function zetLive(el, tekst) {
    /* Dezelfde tekst opnieuw schrijven laat sommige schermlezers alsnog
       voorlezen; alleen bij een echte wijziging aanraken. */
    if (el.textContent === tekst) return;
    el.textContent = tekst;
  }
  var verbruikTimer = null;
  var verbruikGemeld = '';
  function meldVerbruik(zin) {
    if (verbruikTimer) clearTimeout(verbruikTimer);
    verbruikTimer = setTimeout(function () {
      verbruikTimer = null;
      if (zin === verbruikGemeld) return;
      verbruikGemeld = zin;
      document.getElementById('et-kh-verbruik-live').textContent = zin;
    }, 700);
  }
  function renderInvoerDynamisch() {
    renderVerbruik();
    renderLimiet();
    renderNote();
    renderFooterGeldig();
  }
  function renderInvoer() {
    var elektrisch = state.doel === 'ingieten' && state.cSysteem === 'elektrisch';
    /* Laagdikte alvast invullen zodra het veld in beeld komt en de klant er nog
       niets heeft neergezet. Moet vóór renderVerbruik/renderNote/renderRecap,
       en renderStap roept renderFooterGeldig hierna aan, dus de adviesknop
       staat meteen goed. */
    if (mmNodig() && state.mm === null) {
      zetMm(elektrisch ? KH_CONFIG.elektrischMinMm : KH_CONFIG.mmStandaard);
    }
    document.getElementById('et-kh-mm-wrap').hidden = !mmNodig();
    document.getElementById('et-kh-invoer-sub').textContent = invoerSubTekst(elektrisch);
    renderVerbruik();
    renderLimiet();
    renderNote();
    renderRecap();
  }
  /* Grens- en onzinmeldingen; het mm-veld telt alleen mee als het zichtbaar is. */
  function renderLimiet() {
    var el = document.getElementById('et-kh-invoer-limiet');
    var delen = [];
    if (invoerMelding.m2) delen.push(invoerMelding.m2);
    if (mmNodig() && invoerMelding.mm) delen.push(invoerMelding.mm);
    var tekst = delen.join(' ');
    zetLive(el, tekst);
    el.classList.toggle('is-leeg', !tekst);
    el.classList.toggle('is-warn', !!tekst);
  }
  /* Deze zin staat alleen bij de twee paden die met de kg/m²/mm-formule
     rekenen. Pad B ("we rekenen veilig met 8 m²") en de vaste systeemcijfers
     in pad C zitten al aan de veilige kant; daar zou een margeadvies de
     toelichting tegenspreken.
     De marge-regel is gelijkgetrokken met de verbruikscalculator op de
     productpagina (snippets/product-verbruik-calculator.liquid: "Indicatie op
     basis van het gemiddelde verbruik; houd 10% marge aan"). Beide rekenen
     met dezelfde formule; "zonder extra marge" zei hier het tegenovergestelde
     van wat de PDP bij exact dezelfde som adviseert. Het aantal zelf blijft
     de kale uitkomst — dat is ook wat de PDP-knop "Neem over" in de stepper
     zet — en het margeadvies staat er als advies bij. */
  var KAAL = ' Dit is het kale verbruik: houd net als op de productpagina 10% marge aan.';
  function invoerSubTekst(elektrisch) {
    if (state.doel === 'egaliseren') return 'Meet de laagdikte op het diepste punt — decimalen mogen.' + KAAL;
    if (state.doel === 'sleuven') return 'Alleen het vloeroppervlak met sleuven — de mortel vult de sleuven, geen volle laag.';
    if (elektrisch) return 'Minimaal 5 mm dekking over het systeem — dikker invoeren mag.' + KAAL;
    return 'De laagdikte ligt vast per systeem — alleen je oppervlakte is nodig.';
  }
  function renderVerbruik() {
    var formule = document.getElementById('et-kh-formule');
    var uit = document.getElementById('et-kh-zakken');
    var eenheid = document.getElementById('et-kh-eenheid');
    var adv = stapGeldig('invoer') ? resolveAdvies(state) : null;
    if (!adv || !adv.hoofd) {
      formule.textContent = mmNodig()
        ? 'Vul oppervlakte en laagdikte in om het verbruik te berekenen'
        : 'Vul je oppervlakte in om het verbruik te berekenen';
      uit.textContent = '—';
      eenheid.textContent = '';
      meldVerbruik(''); /* niets te melden zolang er geen uitkomst is */
      return;
    }
    /* Het zakgewicht komt uit KH_CONFIG.zakKg, hetzelfde getal waar de formule
       door deelt. Hier stond het metafield specs.inhoud_kg: zette een beheerder
       dat op 25, dan noemde het scherm 25 kg terwijl de berekening met 20
       doorging. De PDF legt 20 kg vast voor alle producten in deze drie paden;
       het metafield is daarom uit het datablock gehaald (zie
       snippets/keuzehulp-modal.liquid) in plaats van hier genegeerd. */
    var inhoudTekst = 'van ' + decimaal(KH_CONFIG.zakKg) + ' kg';
    formule.textContent = adv.hoofd.formuleTekst;
    uit.textContent = '± ' + zakLabel(adv.hoofd.qty);
    eenheid.textContent = inhoudTekst;
    /* Eén zin voor de schermlezer: de drie zichtbare vakjes los voorgelezen
       ("26 zakken" … "van 20 kg") missen hun onderling verband. */
    meldVerbruik('Geschat verbruik: ongeveer ' + zakLabel(adv.hoofd.qty) + ' ' + inhoudTekst +
      '. Berekening: ' + adv.hoofd.formuleTekst + '.');
  }
  function renderNote() {
    var note = document.getElementById('et-kh-invoer-note');
    var tekst = null;
    var warn = false;
    if (state.doel === 'sleuven') {
      tekst = '8–10 m² per zak van 20 kg — we rekenen veilig met 8 m².';
    } else if (state.doel === 'egaliseren') {
      /* Zelfde melding als op de resultaatkaart, maar al tijdens het typen:
         een laagdikte onder het bereik van het geadviseerde product. */
      var advA = stapGeldig('invoer') ? resolveAdvies(state) : null;
      if (advA && advA.bereikNoot) {
        tekst = advA.bereikNoot;
        warn = true;
      }
    } else if (state.doel === 'ingieten') {
      if (state.cSysteem === 'elektrisch') {
        if (state.mm && state.mm < KH_CONFIG.elektrischMinMm) {
          tekst = 'Minimaal 5 mm dekking bij elektrische vloerverwarming — we rekenen met 5 mm.';
          warn = true;
        }
      } else if (state.cSysteem === 'noppenplaat') {
        tekst = 'Praktijkcijfer 34 kg/m²: 20 mm systeemhoogte plus 5 mm dekking boven de noppen.';
      } else if (state.cSysteem) {
        tekst = 'Praktijkcijfer 39 kg/m², met minimaal 5 mm dekking boven het hoogste punt.';
      }
    }
    zetLive(note, tekst || '');
    note.classList.toggle('is-leeg', !tekst);
    note.classList.toggle('is-warn', warn);
  }
  function renderRecap() {
    var wrap = document.getElementById('et-kh-recap-chips');
    wrap.innerHTML = '';
    var seq = bepaalStappen(state);
    var chips = [];
    seq.forEach(function (id) {
      if (id === 'invoer' || !stapGeldig(id)) return;
      chips.push({ label: chipLabel(id), stap: id });
    });
    if (!chips.length) {
      var leeg = document.createElement('span');
      leeg.className = 'et-kh-recap__leeg';
      leeg.textContent = 'Nog geen antwoorden.';
      wrap.appendChild(leeg);
      return;
    }
    chips.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'et-kh-chip-edit';
      b.setAttribute('aria-label', c.label + ' aanpassen');
      b.innerHTML = c.label + ' <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.3 2.7l2 2L5 13l-2.7.7L3 11l8.3-8.3z"/></svg>';
      b.addEventListener('click', function () { gaNaarStap(c.stap); });
      wrap.appendChild(b);
    });
  }
  function chipLabel(id) {
    switch (id) {
      case 'doel': return LABELS.doel[state.doel];
      case 'a-ondergrond': return LABELS.groep[state.groep];
      case 'vocht': return LABELS.vocht[state.vocht];
      case 'b-ondergrond': return LABELS.bOndergrond[state.bOndergrond];
      case 'b-zelfdedag': return LABELS.bZelfdeDag[state.bZelfdeDag];
      case 'c-systeem': return LABELS.cSysteem[state.cSysteem];
      default: return '';
    }
  }

  /* ===== Resultaat ===== */
  /* De levertijdbelofte zoals hij in de markup staat, inclusief de <br> die de
     CSS op smalle schermen uitzet. Bij een bulkadvies zetten we er een andere
     tekst neer, en daarna moet de oorspronkelijke terug kunnen komen. */
  var LEVERING_HTML = (document.getElementById('et-kh-res-foot-levering') || {}).innerHTML || '';
  /* De titel noemt de laagdikte waarmee gerekend is, niet de ruwe invoer: bij
     elektrische vloerverwarming onder 5 mm zijn dat verschillende getallen en
     moet de klant het gerekende getal terugzien (adv.rekenNoot legt uit waarom). */
  function resTitel(advies) {
    var m2 = decimaal(state.m2);
    var rekenMm = advies && advies.rekenMm ? advies.rekenMm : null;
    if (state.doel === 'egaliseren') {
      var t = 'Voor ' + m2 + ' m² op ' + LABELS.groepZin[state.groep];
      if (rekenMm) t += ', laag van ' + decimaal(rekenMm) + ' mm';
      return t;
    }
    if (state.doel === 'sleuven') {
      return 'Voor ' + m2 + ' m² sleuven dichtzetten op ' + LABELS.bOndergrondZin[state.bOndergrond];
    }
    var c = 'Voor ' + m2 + ' m² ingieten van ' + LABELS.cSysteemZin[state.cSysteem];
    if (rekenMm) c += ', laag van ' + decimaal(rekenMm) + ' mm';
    return c;
  }
  function rolLabel(n) {
    return n + (n === 1 ? ' rol' : ' rollen');
  }
  /* Noot op de randisolatierij. Twee getallen met een verschillende status,
     en dat verschil moet zichtbaar zijn: de omtrek is een schatting uit het
     oppervlak (4 x wortel, de kortst mogelijke omtrek) en staat er met een
     ± en "geschat" bij; de 25 m per rol is een productgegeven uit de
     omschrijving van 'Randisolatie met plakrand' ("een lengte van 25 meter",
     nagekeken 08-09-2026). Dat getal staat in geen enkel metafield, dus het
     staat hardgecodeerd in KH_CONFIG.randRolMeter: verandert de leverancier
     de rollengte, dan moet dit mee. "Meet je omtrek na" blijft staan, dat is
     de indekking bij een langwerpige of L-vormige ruimte. */
  function randNoot(m2, rollen) {
    return 'Geschat ±' + decimaal(Math.ceil(randOmtrek(m2))) + ' m omtrek: ' + rolLabel(rollen) +
      ' van ' + decimaal(KH_CONFIG.randRolMeter) + ' m — meet je omtrek na';
  }
  /* De onderdelen die op de resultaatkaarten staan, in dezelfde volgorde.
     Precies dit gaat mee in de WhatsApp-tekst: het bericht mag niets noemen
     wat de klant niet op zijn scherm zag (en niets weglaten wat er wel stond).
     Daarom dezelfde voorwaarden als in toonResultaat: een extra telt alleen
     mee als het product ook echt resolvet. */
  function zichtbareExtras(advies) {
    var uit = { voorstrijk: null, rand: 0, tools: [] };
    /* De voorstrijkrij staat er zodra het advies er een heeft, ook als dat
       product zelf nog niet online is (dan met de fallbacktitel en een eigen
       badge). Het aantal bussen staat er alleen bij als het product bestaat —
       precies zoals op de kaart. */
    if (advies.voorstrijk) uit.voorstrijk = advies.voorstrijk;
    /* Randisolatie telt mee zodra het advies hem voorschrijft, óók als het
       product niet resolvet. Stond hier eerder een && product('randisolatie'),
       en dan viel een verplicht onderdeel (PDF: vanaf 5 mm) stilzwijgend uit de
       kaarten, uit het totaal én uit dit bericht — de klant kwam materiaal
       tekort zonder dat hij ergens iets miste. Een niet-resolvende voorstrijk
       bleef in dezelfde situatie wél staan; dat verschil is nu weg. */
    if (advies.randisolatie) uit.rand = Math.max(1, advies.randRollen);
    advies.gereedschap.forEach(function (k) { if (product(k)) uit.tools.push(k); });
    return uit;
  }
  /* WhatsApp-tekst voor de adviesroutes (nvt en uitverkocht): het volledige advies,
     inclusief de onderdelen die op de resultaatkaarten staan. Zonder die regels
     kreeg de specialist een bericht dat minder bevatte dan de klant op zijn
     scherm zag. Productnamen komen altijd uit titelVan(), nooit uit de sleutel
     zelf — anders stond er 'mixer' of 's500' in het bericht. */
  function waUrl(advies, modus) {
    var copy = KH_CONFIG.route[modus] || KH_CONFIG.route.nvt;
    var delen = [
      'Hallo, ik heb de keuzehulp ingevuld.',
      'Advies: ' + titelVan(advies.hoofd.key) + ' (' + zakLabel(advies.hoofd.qty) + ').',
      'Oppervlakte: ' + decimaal(state.m2) + ' m².'
    ];
    if (state.doel === 'egaliseren' && state.mm) {
      delen.push('Laagdikte: ' + decimaal(state.mm) + ' mm, ondergrond: ' + LABELS.groepZin[state.groep] + '.');
    }
    if (state.doel === 'sleuven') {
      delen.push('Sleuven in ' + LABELS.bOndergrondZin[state.bOndergrond] + '.');
    }
    if (state.doel === 'ingieten') {
      var sys = 'Systeem: ' + LABELS.cSysteem[state.cSysteem];
      if (state.cSysteem === 'elektrisch' && state.mm) sys += ', laagdikte ' + decimaal(Math.max(KH_CONFIG.elektrischMinMm, state.mm)) + ' mm';
      delen.push(sys + '.');
    }
    var zichtbaar = zichtbareExtras(advies);
    var nodig = [];
    if (zichtbaar.voorstrijk) {
      nodig.push(titelVan(zichtbaar.voorstrijk.key) +
        (product(zichtbaar.voorstrijk.key) ? ' (' + busLabel(zichtbaar.voorstrijk.qty) + ')' : ' (staat nog niet online)'));
    }
    if (zichtbaar.rand) {
      nodig.push(titelVan('randisolatie') + ' (' + rolLabel(zichtbaar.rand) +
        (product('randisolatie') ? '' : ', staat nog niet online') + ')');
    }
    if (nodig.length) delen.push('Daarbij nodig volgens de keuzehulp: ' + nodig.join(' en ') + '.');
    if (zichtbaar.tools.length) {
      var toolTitels = [];
      zichtbaar.tools.forEach(function (k) { toolTitels.push(titelVan(k)); });
      delen.push('Optioneel gereedschap: ' + toolTitels.join(', ') + '.');
    }
    delen.push(copy.waSlot);
    return 'https://wa.me/' + WA_NUMMER + '?text=' + encodeURIComponent(delen.join(' '));
  }
  function busLabel(n) {
    return n + (n === 1 ? ' bus' : ' bussen');
  }
  /* "mixer, prikroller, rakel en mengemmer" — kleine letter, want de tekst
     staat achter de vetgezette lead op dezelfde regel. */
  function zinLijst(delen) {
    if (delen.length < 2) return delen[0] || '';
    return delen.slice(0, -1).join(', ') + ' en ' + delen[delen.length - 1];
  }
  /* Het aantal volgt uit een rekenaanname (KH_CONFIG.voorstrijkM2PerCan), geen
     opgave van de fabrikant: dus "geschat", en gewoon Nederlands ("bus").
     Sinds 08-09-2026 staat het gerekende rendement er ook bij. Het staat in
     geen enkele bron (niet in de PDF, niet in een metafield, niet in de
     productomschrijving), en dan hoort de klant te zien waarmee we rekenen —
     net zoals pad B "8-10 m² per zak, we rekenen veilig met 8" laat zien. */
  function busTekst(bussen, m2) {
    return 'geschat ' + busLabel(bussen) + ' voor ' + decimaal(m2) + ' m² (±' +
      decimaal(KH_CONFIG.voorstrijkM2PerCan) + ' m² per bus)';
  }
  /* Toegankelijke naam van een extra-rij. De rij is zelf de knop, en een
     aria-label overschrijft de zichtbare inhoud: product, hoeveelheid, prijs
     en een eventuele voorraadmelding moeten er dus alle vier in staan. */
  function extraLabel(titel, hoeveelheid, prijs, noot) {
    var delen = [titel];
    if (hoeveelheid) delen.push(hoeveelheid);
    if (prijs) delen.push(prijs);
    if (noot) delen.push(noot);
    return delen.join(', ') + ' — meenemen in je bestelling';
  }
  /* Toegankelijke naam van een rij die niets meer schakelt. Zelfde opbouw als
     extraLabel, maar zonder prijs en zonder "meenemen in je bestelling": er
     valt hier niets aan of uit te zetten, alleen te lezen. */
  function infoLabel(titel, hoeveelheid, reden) {
    var delen = [titel];
    if (hoeveelheid) delen.push(hoeveelheid);
    return delen.join(', ') + ' — ' + reden;
  }
  /* Een rij die niets meer schakelt (adviesroute, of een extra die zelf niet
     online staat) blijft staan als informatie. aria-pressed moet er dan af:
     een niet-schakelbaar element hoort geen ingedrukt-status te melden. De
     toegankelijke naam blijft wél staan, nu als infoLabel. Zonder label viel
     de naam terug op de rij-inhoud, en dan kwam eerst de alt-tekst van de
     packshot en daarna dezelfde productnaam als titel voorbij — bij de
     gereedschapsrij zelfs een mixer-alt vóór "Gereedschapsset (4 delen)".
     De packshots in deze rijen staan daarom op alt="" (zie toonResultaat):
     ze herhalen de titel die er direct naast staat. */
  function zetRijInfo(rij, label) {
    rij.classList.add('is-info');
    rij.disabled = true;
    rij.removeAttribute('aria-pressed');
    if (label) rij.setAttribute('aria-label', label);
    else rij.removeAttribute('aria-label');
  }
  function zetRijKnop(rij, label) {
    rij.classList.remove('is-info');
    rij.disabled = false;
    rij.setAttribute('aria-label', label);
    /* aria-pressed zet syncOpts, na alle rijen */
  }
  function toonResultaat() {
    var advies = resolveAdvies(state);
    if (!advies) {
      toonSpecialist();
      return;
    }
    huidigAdvies = advies;
    verbergCartFout();
    /* Extras: de keuzes van de klant blijven staan zolang dezelfde kaarten
       opnieuw op tafel liggen. Heen en weer via "Antwoorden aanpassen" is
       sinds de terugknop de bedoelde route; wie de gereedschapsset aanvinkt
       en daarna zijn m² corrigeert, mag die keuze niet stil kwijtraken.
       Alleen bij een andere samenstelling vallen we terug op de standaard. */
    var samenstelling = [
      advies.voorstrijk ? advies.voorstrijk.key : '-',
      advies.randisolatie ? 'rand' : '-',
      advies.gereedschap.join('+')
    ].join('|');
    if (samenstelling !== extrasVoorSamenstelling) {
      extras = { voorstrijk: true, rand: true, tools: false };
      extrasVoorSamenstelling = samenstelling;
    }

    document.getElementById('et-kh-res-title').textContent = resTitel(advies);

    /* Waarschuwingsbanner (gips + vocht) */
    var alertEl = document.getElementById('et-kh-alert');
    alertEl.hidden = !advies.waarschuwing;
    document.getElementById('et-kh-alert-tekst').textContent = advies.waarschuwing || '';

    /* Hoofdproduct, en de twee routes waarin de modal niets afrekent.
       nvt      = het product staat nog niet online (DRAFT).
       uitverkocht = het hoofdproduct is niet te koop (beschikbaar === false).
                  De cart-add zou de hele aanvraag laten weigeren; de
                  productpagina zet in dezelfde situatie de koopknop op
                  disabled + "Uitverkocht". Hier gaat de knop naar WhatsApp.
       Een palletroute is er niet meer (21-09-2026): elk aantal gaat gewoon in
       de winkelwagen, de hoogste trede heeft een open einde.
       Beide routes tonen dezelfde weergave: geen toggles en geen bedragen, en
       het volledige advies gaat mee in de WhatsApp-tekst. */
    var hoofdProd = product(advies.hoofd.key);
    var nvt = !hoofdProd;
    var qty = advies.hoofd.qty;
    var hoofdUitverkocht = !!hoofdProd && hoofdProd.beschikbaar === false;
    var viaAdvies = nvt || hoofdUitverkocht;
    /* Volgorde van de routes: bestaat het product niet, dan valt er niets te
       zeggen over voorraad. Uitverkocht is de laatste zeef. */
    var routeCopy = nvt ? KH_CONFIG.route.nvt : KH_CONFIG.route.uitverkocht;
    huidigViaAdvies = viaAdvies;
    var img = document.getElementById('et-kh-res-img');
    if (hoofdProd && hoofdProd.img) { img.src = hoofdProd.img; img.hidden = false; } else { img.hidden = true; }
    img.alt = titelVan(advies.hoofd.key);
    document.getElementById('et-kh-res-product').textContent = titelVan(advies.hoofd.key);
    document.getElementById('et-kh-res-why').textContent = advies.waarom || '';
    /* Gevuld als we met een andere laagdikte rekenen dan de invoer (elektrisch
       onder 5 mm) of als de laagdikte onder het bereik van het product ligt.
       De twee sluiten elkaar uit — de clamp zit in pad C, het bereik in pad A —
       maar we zetten ze samen neer zodat een derde noot er zonder gedoe bij kan. */
    var rekenEl = document.getElementById('et-kh-res-reken');
    var rekenTekst = [advies.rekenNoot, advies.bereikNoot].filter(Boolean).join(' ');
    rekenEl.hidden = !rekenTekst;
    rekenEl.textContent = rekenTekst;
    document.getElementById('et-kh-res-nvt').hidden = !nvt;
    /* De voorraadbadge zegt niet meer "Op voorraad": het datablock kent alleen
       variant.available (er is er minstens één), en dat is geen belofte over
       de hele geadviseerde hoeveelheid. "Online bestelbaar" is precies wat we
       weten — en het spiegelt de nvt-badge ernaast. */
    document.getElementById('et-kh-res-stock').hidden = viaAdvies;
    /* De uitverkocht-badge hoort bij de uitverkocht-route; naast "Nog niet
       online bestelbaar" kan hij per definitie niet staan. */
    document.getElementById('et-kh-res-uitverkocht').hidden = !hoofdUitverkocht;

    var calcEl = document.getElementById('et-kh-res-calc');
    var priceEl = document.getElementById('et-kh-res-price');
    var noteEl = document.getElementById('et-kh-res-note');
    resBedragen.hoofd = 0;
    if (hoofdProd && !viaAdvies) {
      var tredes = staffelTredes(hoofdProd);
      var heeftStaffel = tredes.length > 0;
      /* De trede waar dit aantal in valt (de hoogste die het haalt), en de
         eerste trede om naar te verwijzen zolang het aantal er nog onder
         zit. */
      var trede = staffelTrede(tredes, qty);
      var eersteTrede = heeftStaffel ? tredes[0] : null;
      /* De prijs op dit scherm is de prijs die de winkelwagen straks rekent.
         Voor producten mét automatische korting (staffelAuto, per product uit
         het datablock: IKKO, actief vanaf di 15-09-2026 15:00) is dat de
         tredeprijs; voor de rest (UZIN/Atlas/Mapei: wel metavelden, geen
         korting) de gewone variantprijs. Ooit stond hier onvoorwaardelijk de
         staffelprijs met "toegepast"-vinkje: bij 40 zakken IKKO 330 rekende
         het scherm 536,80 voor terwijl de winkelwagen 547,60 rekende. */
      var hoofdAuto = staffelAuto(hoofdProd);
      var unit = (trede && hoofdAuto) ? trede.prijs : hoofdProd.prijs;
      resBedragen.hoofd = qty * unit;
      calcEl.textContent = zakLabel(qty) + ' × ' + fmt(unit);
      priceEl.textContent = fmt(resBedragen.hoofd);
      noteEl.hidden = !heeftStaffel;
      if (!heeftStaffel) {
        noteEl.textContent = '';
      } else if (trede && hoofdAuto) {
        noteEl.innerHTML = 'Staffelprijs toegepast ' + CHECK_SVG;
      } else if (trede) {
        /* De staffel is de gepubliceerde prijs van de winkel, dus we noemen
           hem — maar zonder te claimen dat hij in dit bedrag zit. Kort
           gehouden: dit blok staat rechts naast de productnaam en groeit mee
           met zijn eigen tekst. De trede die erbij staat is die van dít
           aantal: bij 60 zakken de prijs vanaf 50, niet die vanaf 25. */
        noteEl.textContent = 'Staffelprijs ' + fmt(trede.prijs) + ' per zak op aanvraag';
      } else {
        noteEl.textContent = 'Vanaf ' + eersteTrede.min + ' zakken: ' + fmt(eersteTrede.prijs) + ' per zak' +
          (hoofdAuto ? '' : ' op aanvraag');
      }
    } else {
      /* Geen bedrag: bij nvt is er geen prijs, en bij uitverkocht valt er
         niets af te rekenen. */
      calcEl.textContent = advies.hoofd.formuleTekst;
      priceEl.textContent = zakLabel(qty);
      noteEl.hidden = false;
      noteEl.textContent = routeCopy.prijsNoot;
    }

    /* Extra's — één blok met compacte rijen. De rij zelf is de knop, dus
       et-kh-opt-<naam> is tegelijk de rij: hidden zetten verbergt de hele rij.
       Kan er niets besteld worden, dan blijft de rij staan als informatie
       (zetRijInfo) in plaats van te verdwijnen. */

    /* Voorstrijk (pad A en B; null-product = mini-nvt zonder toggle) */
    var vk = advies.voorstrijk;
    var vkRij = document.getElementById('et-kh-opt-voorstrijk');
    var vkPrice = document.getElementById('et-kh-voorstrijk-price');
    var vkNvt = document.getElementById('et-kh-voorstrijk-nvt');
    resBedragen.voorstrijk = 0;
    vkRij.hidden = !vk;
    if (vk) {
      var vkProd = product(vk.key);
      var vkImg = document.getElementById('et-kh-voorstrijk-img');
      if (vkProd && vkProd.img) { vkImg.src = vkProd.img; vkImg.hidden = false; } else { vkImg.hidden = true; }
      vkImg.alt = ''; /* decoratief: de titel staat ernaast (zie zetRijInfo) */
      document.getElementById('et-kh-voorstrijk-title').textContent = titelVan(vk.key);
      var vkDesc = KH_CONFIG.voorstrijkDesc[vk.key] || '';
      var vkUitverkocht = !!vkProd && vkProd.beschikbaar === false;
      document.getElementById('et-kh-voorstrijk-uitverkocht').hidden = !vkUitverkocht;
      if (vkProd) {
        document.getElementById('et-kh-voorstrijk-desc').textContent = vkDesc + ' · ' + busTekst(vk.qty, state.m2);
        vkNvt.hidden = true;
      } else {
        document.getElementById('et-kh-voorstrijk-desc').textContent = vkDesc;
        vkNvt.hidden = false;
        extras.voorstrijk = false;
      }
      /* Een uitverkochte extra mag niet aanvinkbaar blijven: hij stond
         standaard áán en liet daarmee de hele cart-add mislukken — inclusief
         het hoofdproduct dat wél leverbaar was. Hij blijft staan als
         informatie, met de badge die de reden geeft. */
      var vkBestelbaar = !!vkProd && !viaAdvies && !vkUitverkocht;
      vkPrice.hidden = !vkBestelbaar;
      if (vkBestelbaar) {
        resBedragen.voorstrijk = vk.qty * vkProd.prijs;
        vkPrice.textContent = fmt(resBedragen.voorstrijk);
        zetRijKnop(vkRij, extraLabel(titelVan(vk.key), busLabel(vk.qty), vkPrice.textContent, null));
      } else {
        var vkReden = 'nog niet online bestelbaar';
        if (vkProd) vkReden = vkUitverkocht && !viaAdvies ? 'tijdelijk uitverkocht' : routeCopy.rijReden;
        zetRijInfo(vkRij, infoLabel(titelVan(vk.key), vkProd ? busLabel(vk.qty) : null, vkReden));
        /* Alleen uitzetten als dit onderdeel zelf niet te bestellen is. In een
           adviesroute telt de keuze toch niet mee (geen bedragen, geen
           cart-add), en dan mag hij niet stil verdwijnen voor het volgende
           advies dat wél afrekenbaar is. */
        if (!vkProd || vkUitverkocht) extras.voorstrijk = false;
      }
    }

    /* Randisolatie (pad A vanaf 5 mm, pad C altijd).
       De rij hangt aan het advies, niet aan het product. Stond hier eerder
       "advies.randisolatie && !!randProd", en dan verdween een volgens de PDF
       verplicht onderdeel geruisloos zodra het product niet resolvet: geen
       kaart, geen bedrag, geen regel in de WhatsApp-tekst — terwijl een
       niet-resolvende voorstrijk in dezelfde situatie netjes bleef staan met
       fallbacktitel en badge. Randisolatie krijgt nu precies dezelfde
       behandeling; het aantal rollen blijft onze eigen schatting en staat er
       ook zonder product bij, zodat de klant weet wat hij moet regelen. */
    var randProd = product('randisolatie');
    var randRij = document.getElementById('et-kh-opt-rand');
    var toonRand = advies.randisolatie;
    randRij.hidden = !toonRand;
    resBedragen.rand = 0;
    if (toonRand) {
      var randQty = Math.max(1, advies.randRollen);
      document.getElementById('et-kh-rand-kicker').textContent =
        state.doel === 'ingieten' ? 'Vast in de opbouw' : 'Verplicht vanaf 5 mm';
      var randImg = document.getElementById('et-kh-rand-img');
      if (randProd && randProd.img) { randImg.src = randProd.img; randImg.hidden = false; } else { randImg.hidden = true; }
      randImg.alt = ''; /* decoratief: de titel staat ernaast */
      document.getElementById('et-kh-rand-title').textContent = titelVan('randisolatie');
      document.getElementById('et-kh-rand-desc').textContent = randNoot(state.m2, randQty);
      var randUitverkocht = !!randProd && randProd.beschikbaar === false;
      document.getElementById('et-kh-rand-nvt').hidden = !!randProd;
      document.getElementById('et-kh-rand-uitverkocht').hidden = !randUitverkocht;
      var randPrice = document.getElementById('et-kh-rand-price');
      var randBestelbaar = !!randProd && !viaAdvies && !randUitverkocht;
      randPrice.hidden = !randBestelbaar;
      if (randBestelbaar) {
        randPrice.textContent = fmt(randQty * randProd.prijs); /* aantal staat in de noot, net als bij de voorstrijk */
        resBedragen.rand = randQty * randProd.prijs;
        zetRijKnop(randRij, extraLabel(titelVan('randisolatie'), rolLabel(randQty), randPrice.textContent, null));
      } else {
        var randReden = 'nog niet online bestelbaar';
        if (randProd) randReden = randUitverkocht && !viaAdvies ? 'tijdelijk uitverkocht' : routeCopy.rijReden;
        zetRijInfo(randRij, infoLabel(titelVan('randisolatie'), rolLabel(randQty), randReden));
        /* Zelfde afweging als bij de voorstrijk: alleen uitzetten als de
           randisolatie zelf niet te bestellen is. */
        if (!randProd || randUitverkocht) extras.rand = false;
      }
    } else {
      extras.rand = false;
    }

    /* Gereedschapsset (opt-in). De set bevat alleen wat vandaag te bestellen
       is: één uitverkocht deel liet anders de complete cart-add mislukken,
       inclusief het hoofdproduct. De kaart heet naar het aantal delen dat er
       echt in zit; de badge "Niet compleet op voorraad" legt uit waarom dat er
       minder dan vier kunnen zijn. In de winkelwagen blijven het losse regels
       (zie zetInWinkelwagen, dezelfde filter). */
    var toolsRij = document.getElementById('et-kh-opt-tools');
    var toolKeys = toolsTeBestellen(advies);
    var tools = toolKeys.map(product);
    resBedragen.tools = 0;
    toolsRij.hidden = !tools.length;
    if (tools.length) {
      var titels = [];
      var korteNamen = [];
      var toolsBedrag = 0;
      var toolsUitverkocht = toolKeys.length !== advies.gereedschap.filter(product).length;
      toolKeys.forEach(function (k) {
        var t = product(k);
        titels.push(t.titel);
        korteNamen.push(KH_CONFIG.gereedschapKort[k] || t.titel);
        toolsBedrag += t.prijs;
      });
      var timg = document.getElementById('et-kh-tools-img');
      if (tools[0].img) { timg.src = tools[0].img; timg.hidden = false; } else { timg.hidden = true; }
      timg.alt = ''; /* decoratief: één packshot voor een set van vier */
      var setTitel = 'Gereedschapsset (' + tools.length + (tools.length === 1 ? ' deel' : ' delen') + ')';
      document.getElementById('et-kh-tools-title').textContent = setTitel;
      document.getElementById('et-kh-tools-desc').textContent = zinLijst(korteNamen);
      document.getElementById('et-kh-tools-uitverkocht').hidden = !toolsUitverkocht;
      var toolsPrice = document.getElementById('et-kh-tools-price');
      toolsPrice.hidden = viaAdvies;
      if (viaAdvies) {
        zetRijInfo(toolsRij, infoLabel(setTitel + ': ' + titels.join(', '), null, routeCopy.rijReden));
      } else {
        toolsPrice.textContent = fmt(toolsBedrag);
        resBedragen.tools = toolsBedrag;
        /* De volledige producttitels staan niet meer op de kaart, dus ze
           moeten wél in de toegankelijke naam van de rij zitten. */
        zetRijKnop(toolsRij, extraLabel(setTitel + ': ' + titels.join(', '), null, toolsPrice.textContent,
          toolsUitverkocht ? 'niet compleet op voorraad' : null));
      }
    } else {
      extras.tools = false;
    }
    /* Twee koppen, twee groepen. "Hier heb je ook nodig" dekte ook de
       gereedschapsset, terwijl die optioneel is en standaard uitstaat — in pad B
       en pad C was dat zelfs de enige rij onder die kop. Elke kop verschijnt
       alleen als er iets onder staat. */
    document.getElementById('et-kh-res-extras-kop-nodig').hidden = vkRij.hidden && randRij.hidden;
    document.getElementById('et-kh-res-extras-kop-optie').hidden = toolsRij.hidden;
    document.getElementById('et-kh-res-extras').hidden = vkRij.hidden && randRij.hidden && toolsRij.hidden;

    /* Stookprotocol (pad C). Het blok is een <details>: op desktop open, op een
       telefoon dicht. De drie stappen zijn niet ingekort — ze kostten alleen op
       390 px ruim 160 px in precies het pad dat toch al niet in één scherm
       paste, en het getal waarop je plant (±21 dagen) staat in de samenvatting.
       Bij elk advies opnieuw zetten, zodat een gebruiker die het openklapte en
       daarna zijn antwoorden aanpast weer de stand voor zijn scherm krijgt. */
    var protocolEl = document.getElementById('et-kh-protocol');
    protocolEl.hidden = !advies.stookprotocol;
    protocolEl.open = !isSmalScherm();

    /* Primaire actie: cart-add, of WhatsApp in een van de twee adviesroutes.
       Het knoplabel verschilt: bij uitverkocht vraagt de klant een levertijd
       aan, bij nvt bestelt hij via WhatsApp. */
    var btnCart = document.getElementById('et-kh-btn-cart');
    var btnWa = document.getElementById('et-kh-btn-wa');
    btnCart.hidden = viaAdvies;
    btnWa.hidden = !viaAdvies;
    if (viaAdvies) {
      btnWa.href = waUrl(advies, nvt ? 'nvt' : 'uitverkocht');
      document.getElementById('et-kh-btn-wa-label').textContent = routeCopy.knop;
    }
    /* "Check met specialist" wijst naar hetzelfde WhatsApp-nummer als de
       primaire knop in de adviesroutes; daar is het een dubbele route. */
    document.getElementById('et-kh-btn-specialist').hidden = viaAdvies;

    /* Footer: een totaalbedrag zonder afrekenknop is misleidend, dus in de
       adviesroutes staat daar een korte uitleg (en geen levertijdbelofte). */
    document.getElementById('et-kh-res-totaalblok').hidden = viaAdvies;
    /* Levertijd. "Voor 14:00 besteld, volgende werkdag geleverd" is de belofte
       uit de topbar en dekt volgens de PDP-checkregel ook één pallet. Vanaf
       BULK_VANAF (±1.000 kg, één volle pallet — zie de comment daar) laten we
       hem vallen: meer dan één pallet beloven we niet. */
    var leveringEl = document.getElementById('et-kh-res-foot-levering');
    var bulk = !viaAdvies && qty >= BULK_VANAF;
    leveringEl.hidden = viaAdvies;
    if (bulk) {
      leveringEl.textContent = KH_CONFIG.levertijdBulk;
    } else {
      leveringEl.innerHTML = LEVERING_HTML;
    }
    var voetUitleg = document.getElementById('et-kh-res-foot-nvt');
    voetUitleg.hidden = !viaAdvies;
    voetUitleg.textContent = routeCopy.voet;

    syncOpts();
    renderTotaal();
    toonView('resultaat');
    meetAdvies(advies, qty, nvt, hoofdUitverkocht);
    /* De aangeklikte knop ("Toon mijn advies") is nu verborgen; zonder deze
       regel valt de toetsenbordfocus buiten de dialog. */
    modal.focus();
  }
  /* Informatieve rijen (.is-info) slaan we over: die hebben bewust geen
     aria-pressed, want er valt niets aan of uit te zetten. */
  function syncOpts() {
    ['voorstrijk', 'rand', 'tools'].forEach(function (naam) {
      var rij = document.getElementById('et-kh-opt-' + naam);
      if (rij.classList.contains('is-info')) return;
      rij.setAttribute('aria-pressed', extras[naam] ? 'true' : 'false');
    });
  }
  function berekenTotaal() {
    return resBedragen.hoofd +
      (extras.voorstrijk ? resBedragen.voorstrijk : 0) +
      (extras.rand ? resBedragen.rand : 0) +
      (extras.tools ? resBedragen.tools : 0);
  }
  function renderTotaal() {
    document.getElementById('et-kh-totaal').textContent = fmt(berekenTotaal());
  }
  /* Opt-in/out extras: alleen totaal bijwerken, geen re-render van de view
     (de modal mag niet naar boven springen bij elke klik). De haak is de hele
     rij; een disabled rij (.is-info) vuurt geen click, dus die hoeft hier geen
     eigen guard. */
  ['voorstrijk', 'rand', 'tools'].forEach(function (naam) {
    document.getElementById('et-kh-opt-' + naam).addEventListener('click', function () {
      extras[naam] = !extras[naam];
      this.setAttribute('aria-pressed', extras[naam] ? 'true' : 'false');
      renderTotaal();
    });
  });

  /* Terug vanuit het resultaat naar de vragen: laatste stap van de huidige
     reeks (de invoer-stap), zodat m² en mm meteen te corrigeren zijn. Alle
     antwoorden blijven staan; via de recap-chips daar is elke eerdere stap
     bereikbaar. Focus naar de modal, want de knop zelf verdwijnt. */
  document.getElementById('et-kh-res-terug').addEventListener('click', function () {
    var seq = bepaalStappen(state);
    gaNaarStap(seq[seq.length - 1]);
    modal.focus();
  });

  /* ===== Winkelwagen =====
     Native patroon uit app.js (ProductCard.quickAdd/renderContents):
     sections meesturen, daarna cart-drawer + cart-bubble verversen en de
     drawer openen. Fallback: window.location = '/cart'. */
  var CART_SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];
  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function verversCart(parsedState) {
    if (!parsedState.sections) return false;
    var geslaagd = false;
    CART_SECTIONS.forEach(function (section) {
      var wrap = document.getElementById(section.id);
      if (!wrap || !parsedState.sections[section.section]) return;
      var elementToReplace = wrap.querySelector(section.selector) || wrap;
      var inner = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      if (inner === null) return;
      elementToReplace.innerHTML = inner;
      geslaagd = true;
    });
    if (!geslaagd) return false;
    if (typeof CartDrawer !== 'undefined') {
      new CartDrawer();
    }
    if (document.getElementById('Cart-Drawer')) {
      document.body.classList.add('open-cc');
      document.getElementById('Cart-Drawer').classList.add('active');
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    return true;
  }
  /* Foutmelding in de modal i.p.v. een kale window.alert: /cart/add.js weigert
     bij één ontoereikende regel de hele aanvraag, dus de klant moet zien wat
     er misging én wat hij eraan kan doen. De reden noemen we niet meer zelf:
     alle elf ACTIEVE keuzehulpproducten staan op inventoryPolicy CONTINUE
     (doorverkopen bij 0, drie staan zelfs negatief), dus /cart/add.js weigert
     hier nooit op voorraad. "Zet een onderdeel uit" stuurde de klant daarmee
     op een spoor dat het probleem niet oplost; de melding van de winkel zelf
     staat er nog wel bij, want die is wél waar. */
  function toonCartFout(tekst) {
    document.getElementById('et-kh-cart-fout-tekst').textContent = tekst;
    document.getElementById('et-kh-cart-fout').hidden = false;
  }
  function verbergCartFout() {
    document.getElementById('et-kh-cart-fout').hidden = true;
  }
  function zetInWinkelwagen() {
    /* huidigViaAdvies: bij een nvt-product of een uitverkocht product verkoopt deze
       modal niets, net zomin als de productpagina. De knop is dan verborgen;
       dit is het slot voor het geval hij ooit toch bereikbaar wordt. */
    if (!huidigAdvies || huidigViaAdvies) return;
    var btn = document.getElementById('et-kh-btn-cart');
    if (btn.classList.contains('is-loading')) return;
    verbergCartFout();
    /* Alleen wat de winkelwagen ook echt accepteert: het product bestaat én is
       te koop (bestelbaar). /cart/add.js weigert de héle aanvraag zodra één
       regel niet leverbaar is, dus één uitverkochte extra nam anders de rest
       mee in zijn val. Dit is dezelfde filter als op de kaarten, zodat er nooit
       iets wordt meegestuurd wat het scherm niet als bestelbaar toonde. */
    var items = [];
    var hoofdProd = product(huidigAdvies.hoofd.key);
    if (bestelbaar(huidigAdvies.hoofd.key)) items.push({ id: hoofdProd.variant, quantity: huidigAdvies.hoofd.qty });
    if (extras.voorstrijk && huidigAdvies.voorstrijk && bestelbaar(huidigAdvies.voorstrijk.key)) {
      var vkProd = product(huidigAdvies.voorstrijk.key);
      items.push({ id: vkProd.variant, quantity: huidigAdvies.voorstrijk.qty });
    }
    if (extras.rand && huidigAdvies.randisolatie && bestelbaar('randisolatie')) {
      var randProd = product('randisolatie');
      items.push({ id: randProd.variant, quantity: Math.max(1, huidigAdvies.randRollen) });
    }
    if (extras.tools) {
      toolsTeBestellen(huidigAdvies).forEach(function (k) {
        items.push({ id: product(k).variant, quantity: 1 });
      });
    }
    if (!items.length) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: CART_SECTIONS.map(function (s) { return s.section; }).join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          /* Shopify-fout (bv. onvoldoende voorraad): niets is toegevoegd */
          console.error('Keuzehulp cart-add:', response);
          meet('cart_fout', { reden: 'winkel' });
          var reden = response.description || response.message || '';
          toonCartFout('Er is niets toegevoegd — de winkelwagen heeft de aanvraag geweigerd.' +
            (reden ? ' Melding van de winkel: ' + reden : '') + ' Probeer het zo nog eens, of laat ons het regelen:');
          return;
        }
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        }
        meetCart(items);
        closeModal();
        if (!verversCart(response)) {
          window.location = '/cart';
        }
      })
      .catch(function (e) {
        /* Netwerk-/parsefout: melding tonen en de modal open laten, niet naar
           /cart sturen (het item is dan waarschijnlijk niet toegevoegd) */
        console.error('Keuzehulp cart-add:', e);
        meet('cart_fout', { reden: 'netwerk' });
        toonCartFout('Toevoegen aan de winkelwagen is niet gelukt. Controleer je verbinding en probeer het opnieuw, of stuur ons je advies:');
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  }
  document.getElementById('et-kh-btn-cart').addEventListener('click', zetInWinkelwagen);

  /* ===== Specialist-route (generieke fallback) ===== */
  function toonSpecialist() {
    huidigRoute = 'specialist';
    meet('specialist', { stap: huidigeStap });
    toonView('specialist');
    modal.focus(); /* de knop die deze view opriep is nu verborgen */
  }
  document.getElementById('et-kh-spec-terug').addEventListener('click', function () {
    toonView('vragen');
    renderStap();
    modal.focus(); /* idem: de terugknop zelf verdwijnt met de view */
  });

  /* ===== Navigatie & openen/sluiten ===== */
  document.getElementById('et-kh-next').addEventListener('click', volgende);
  document.getElementById('et-kh-prev').addEventListener('click', vorige);
  document.getElementById('et-kh-advies').addEventListener('click', toonResultaat);
  /* Elke WhatsApp-link in de modal (adviesroutes, 'Check met specialist',
     specialist-view) telt als whatsapp-event met de route van dat moment. */
  overlay.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me"]') : null;
    if (a) meet('whatsapp', { route: huidigRoute || 'specialist' });
  });
  overlay.querySelectorAll('[data-close]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    var lijst = verzamelFocusables();
    if (!lijst.length) return;
    var eerste = lijst[0];
    var laatste = lijst[lijst.length - 1];
    var actief = document.activeElement;
    if (!modal.contains(actief)) {
      /* Focus buiten de modal (bv. na een view-wissel): terug naar binnen */
      e.preventDefault();
      (e.shiftKey ? laatste : eerste).focus();
      return;
    }
    if (e.shiftKey && (actief === eerste || actief === modal)) {
      e.preventDefault();
      laatste.focus();
    } else if (!e.shiftKey && actief === laatste) {
      e.preventDefault();
      eerste.focus();
    }
  });

  /* ===== Prefill via triggers =====
     Nieuw: data-doel (+ optioneel data-groep) of data-kh-start (open op de
     startvraag). Legacy: data-ondergrond met oude waarden -> remap. Prefill
     zet de state en springt naar de eerste onbeantwoorde stap. */
  function prefillState(doel, groep) {
    wisPadAntwoorden();
    state.doel = doel;
    state.groep = (doel === 'egaliseren' && LABELS.groep[groep]) ? groep : null;
    renderKaarten();
    huidigeStap = eersteOnbeantwoorde(bepaalStappen(state));
    toonView('vragen');
    renderStap();
  }
  /* data-kh-start (het Vloerverwarming-kaartje) begint écht bij de doelvraag:
     zonder het wissen van het oude doel stond na een eerdere sessie nog
     "Egaliseren" aangevinkt met Volgende actief, en leidde één klik terug het
     verkeerde pad in. Het ingevulde oppervlak blijft staan. */
  function startBijDoel() {
    state.doel = null;
    wisPadAntwoorden();
    renderKaarten();
    huidigeStap = 'doel';
    toonView('vragen');
    renderStap();
  }
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target.closest && e.target.closest('[data-keuzehulp-open], a[href*="#egaline-wijzer"]');
    if (!t || overlay.contains(t)) return;
    e.preventDefault();
    /* Vanuit de cart-drawer gestart (lege staat): eerst de drawer sluiten,
       anders blijft het paneel onder de modal openstaan. Na een cart-add
       heropent verversCart de drawer vanzelf. */
    var vanuitDrawer = t.closest('#Cart-Drawer');
    if (vanuitDrawer) {
      vanuitDrawer.classList.remove('active');
      document.body.classList.remove('open-cc');
    }
    var doel = t.getAttribute('data-doel');
    var groep = t.getAttribute('data-groep');
    var legacy = t.getAttribute('data-ondergrond');
    if (!doel && legacy && LEGACY_REMAP[legacy]) {
      doel = LEGACY_REMAP[legacy].doel;
      groep = LEGACY_REMAP[legacy].groep;
    }
    if (doel && LABELS.doel[doel]) {
      prefillState(doel, groep);
    } else if (t.hasAttribute('data-kh-start')) {
      startBijDoel();
    }
    openModal(t);
  });

  /* Init */
  renderKaarten();
  renderStap();
})();
